{
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "type": "object",
    "title": "WritableManifest",
    "properties": {
        "metadata": {
            "type": "object",
            "title": "ManifestMetadata",
            "description": "Metadata about the manifest",
            "properties": {
                "dbt_schema_version": {
                    "type": "string"
                },
                "dbt_version": {
                    "type": "string",
                    "default": "1.10.0a1"
                },
                "generated_at": {
                    "type": "string"
                },
                "invocation_id": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "invocation_started_at": {
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "env": {
                    "type": "object",
                    "additionalProperties": {
                        "type": "string"
                    },
                    "propertyNames": {
                        "type": "string"
                    }
                },
                "project_name": {
                    "description": "Name of the root project",
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": null
                },
                "project_id": {
                    "description": "A unique identifier for the project, hashed from the project name",
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": null
                },
                "user_id": {
                    "description": "A unique identifier for the user",
                    "anyOf": [
                        {
                            "type": "string",
                            "format": "uuid"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": null
                },
                "send_anonymous_usage_stats": {
                    "description": "Whether dbt is configured to send anonymous usage statistics",
                    "anyOf": [
                        {
                            "type": "boolean"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": null
                },
                "adapter_type": {
                    "description": "The type name of the adapter",
                    "anyOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "null"
                        }
                    ],
                    "default": null
                }
            },
            "additionalProperties": false
        },
        "nodes": {
            "type": "object",
            "description": "The nodes defined in the dbt project and its dependencies",
            "additionalProperties": {
                "anyOf": [
                    {
                        "type": "object",
                        "title": "Seed",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "seed"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "SeedConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "seed"
                                    },
                                    "incremental_strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "batch_size": {
                                        "default": null
                                    },
                                    "lookback": {
                                        "default": 1
                                    },
                                    "begin": {
                                        "default": null
                                    },
                                    "persist_docs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "post-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "pre-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "quoting": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "column_types": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "full_refresh": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "unique_key": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "on_schema_change": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "ignore"
                                    },
                                    "on_configuration_change": {
                                        "enum": ["apply", "continue", "fail"]
                                    },
                                    "grants": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "packages": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "docs": {
                                        "type": "object",
                                        "title": "Docs",
                                        "properties": {
                                            "show": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "node_color": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "contract": {
                                        "type": "object",
                                        "title": "ContractConfig",
                                        "properties": {
                                            "enforced": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "alias_types": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "event_time": {
                                        "default": null
                                    },
                                    "concurrent_batches": {
                                        "default": null
                                    },
                                    "delimiter": {
                                        "type": "string",
                                        "default": ","
                                    },
                                    "quote_columns": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "root_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "MacroDependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "defer_relation": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "DeferRelation",
                                        "properties": {
                                            "database": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "schema": {
                                                "type": "string"
                                            },
                                            "alias": {
                                                "type": "string"
                                            },
                                            "relation_name": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "resource_type": {
                                                "enum": [
                                                    "model",
                                                    "analysis",
                                                    "test",
                                                    "snapshot",
                                                    "operation",
                                                    "seed",
                                                    "rpc",
                                                    "sql_operation",
                                                    "doc",
                                                    "source",
                                                    "macro",
                                                    "exposure",
                                                    "metric",
                                                    "group",
                                                    "saved_query",
                                                    "semantic_model",
                                                    "unit_test",
                                                    "fixture"
                                                ]
                                            },
                                            "name": {
                                                "type": "string"
                                            },
                                            "description": {
                                                "type": "string"
                                            },
                                            "compiled_code": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "meta": {
                                                "type": "object",
                                                "propertyNames": {
                                                    "type": "string"
                                                }
                                            },
                                            "tags": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            "config": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "NodeConfig",
                                                        "properties": {
                                                            "_extra": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "enabled": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "alias": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "schema": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "database": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "tags": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    {
                                                                        "type": "string"
                                                                    }
                                                                ]
                                                            },
                                                            "meta": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "group": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "materialized": {
                                                                "type": "string",
                                                                "default": "view"
                                                            },
                                                            "incremental_strategy": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "batch_size": {
                                                                "default": null
                                                            },
                                                            "lookback": {
                                                                "default": 1
                                                            },
                                                            "begin": {
                                                                "default": null
                                                            },
                                                            "persist_docs": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "post-hook": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "Hook",
                                                                    "properties": {
                                                                        "sql": {
                                                                            "type": "string"
                                                                        },
                                                                        "transaction": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "index": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "sql"
                                                                    ]
                                                                }
                                                            },
                                                            "pre-hook": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "Hook",
                                                                    "properties": {
                                                                        "sql": {
                                                                            "type": "string"
                                                                        },
                                                                        "transaction": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "index": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "sql"
                                                                    ]
                                                                }
                                                            },
                                                            "quoting": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "column_types": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "full_refresh": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "boolean"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "unique_key": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "on_schema_change": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": "ignore"
                                                            },
                                                            "on_configuration_change": {
                                                                "enum": [
                                                                    "apply",
                                                                    "continue",
                                                                    "fail"
                                                                ]
                                                            },
                                                            "grants": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "packages": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "docs": {
                                                                "type": "object",
                                                                "title": "Docs",
                                                                "properties": {
                                                                    "show": {
                                                                        "type": "boolean",
                                                                        "default": true
                                                                    },
                                                                    "node_color": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            "contract": {
                                                                "type": "object",
                                                                "title": "ContractConfig",
                                                                "properties": {
                                                                    "enforced": {
                                                                        "type": "boolean",
                                                                        "default": false
                                                                    },
                                                                    "alias_types": {
                                                                        "type": "boolean",
                                                                        "default": true
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            "event_time": {
                                                                "default": null
                                                            },
                                                            "concurrent_batches": {
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": true
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "database",
                                            "schema",
                                            "alias",
                                            "relation_name",
                                            "resource_type",
                                            "name",
                                            "description",
                                            "compiled_code",
                                            "meta",
                                            "tags",
                                            "config"
                                        ]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "Analysis",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "analysis"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "NodeConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "view"
                                    },
                                    "incremental_strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "batch_size": {
                                        "default": null
                                    },
                                    "lookback": {
                                        "default": 1
                                    },
                                    "begin": {
                                        "default": null
                                    },
                                    "persist_docs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "post-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "pre-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "quoting": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "column_types": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "full_refresh": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "unique_key": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "on_schema_change": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "ignore"
                                    },
                                    "on_configuration_change": {
                                        "enum": ["apply", "continue", "fail"]
                                    },
                                    "grants": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "packages": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "docs": {
                                        "type": "object",
                                        "title": "Docs",
                                        "properties": {
                                            "show": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "node_color": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "contract": {
                                        "type": "object",
                                        "title": "ContractConfig",
                                        "properties": {
                                            "enforced": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "alias_types": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "event_time": {
                                        "default": null
                                    },
                                    "concurrent_batches": {
                                        "default": null
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "SingularTest",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "test"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "TestConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "dbt_test__audit"
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "test"
                                    },
                                    "severity": {
                                        "type": "string",
                                        "default": "ERROR",
                                        "pattern": "^([Ww][Aa][Rr][Nn]|[Ee][Rr][Rr][Oo][Rr])$"
                                    },
                                    "store_failures": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "store_failures_as": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "where": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "limit": {
                                        "anyOf": [
                                            {
                                                "type": "integer"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "fail_calc": {
                                        "type": "string",
                                        "default": "count(*)"
                                    },
                                    "warn_if": {
                                        "type": "string",
                                        "default": "!= 0"
                                    },
                                    "error_if": {
                                        "type": "string",
                                        "default": "!= 0"
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "HookNode",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "operation"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "NodeConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "view"
                                    },
                                    "incremental_strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "batch_size": {
                                        "default": null
                                    },
                                    "lookback": {
                                        "default": 1
                                    },
                                    "begin": {
                                        "default": null
                                    },
                                    "persist_docs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "post-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "pre-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "quoting": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "column_types": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "full_refresh": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "unique_key": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "on_schema_change": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "ignore"
                                    },
                                    "on_configuration_change": {
                                        "enum": ["apply", "continue", "fail"]
                                    },
                                    "grants": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "packages": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "docs": {
                                        "type": "object",
                                        "title": "Docs",
                                        "properties": {
                                            "show": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "node_color": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "contract": {
                                        "type": "object",
                                        "title": "ContractConfig",
                                        "properties": {
                                            "enforced": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "alias_types": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "event_time": {
                                        "default": null
                                    },
                                    "concurrent_batches": {
                                        "default": null
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "index": {
                                "anyOf": [
                                    {
                                        "type": "integer"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "Model",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "model"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "ModelConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "view"
                                    },
                                    "incremental_strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "batch_size": {
                                        "default": null
                                    },
                                    "lookback": {
                                        "default": 1
                                    },
                                    "begin": {
                                        "default": null
                                    },
                                    "persist_docs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "post-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "pre-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "quoting": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "column_types": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "full_refresh": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "unique_key": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "on_schema_change": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "ignore"
                                    },
                                    "on_configuration_change": {
                                        "enum": ["apply", "continue", "fail"]
                                    },
                                    "grants": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "packages": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "docs": {
                                        "type": "object",
                                        "title": "Docs",
                                        "properties": {
                                            "show": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "node_color": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "contract": {
                                        "type": "object",
                                        "title": "ContractConfig",
                                        "properties": {
                                            "enforced": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "alias_types": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "event_time": {
                                        "default": null
                                    },
                                    "concurrent_batches": {
                                        "default": null
                                    },
                                    "access": {
                                        "enum": [
                                            "private",
                                            "protected",
                                            "public"
                                        ],
                                        "default": "protected"
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "access": {
                                "enum": ["private", "protected", "public"],
                                "default": "protected"
                            },
                            "constraints": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "ModelLevelConstraint",
                                    "properties": {
                                        "type": {
                                            "enum": [
                                                "check",
                                                "not_null",
                                                "unique",
                                                "primary_key",
                                                "foreign_key",
                                                "custom"
                                            ]
                                        },
                                        "name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "expression": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "warn_unenforced": {
                                            "type": "boolean",
                                            "default": true
                                        },
                                        "warn_unsupported": {
                                            "type": "boolean",
                                            "default": true
                                        },
                                        "to": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "to_columns": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "columns": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["type"]
                                }
                            },
                            "version": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "number"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "latest_version": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "number"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "deprecation_date": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "defer_relation": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "DeferRelation",
                                        "properties": {
                                            "database": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "schema": {
                                                "type": "string"
                                            },
                                            "alias": {
                                                "type": "string"
                                            },
                                            "relation_name": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "resource_type": {
                                                "enum": [
                                                    "model",
                                                    "analysis",
                                                    "test",
                                                    "snapshot",
                                                    "operation",
                                                    "seed",
                                                    "rpc",
                                                    "sql_operation",
                                                    "doc",
                                                    "source",
                                                    "macro",
                                                    "exposure",
                                                    "metric",
                                                    "group",
                                                    "saved_query",
                                                    "semantic_model",
                                                    "unit_test",
                                                    "fixture"
                                                ]
                                            },
                                            "name": {
                                                "type": "string"
                                            },
                                            "description": {
                                                "type": "string"
                                            },
                                            "compiled_code": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "meta": {
                                                "type": "object",
                                                "propertyNames": {
                                                    "type": "string"
                                                }
                                            },
                                            "tags": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            "config": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "NodeConfig",
                                                        "properties": {
                                                            "_extra": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "enabled": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "alias": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "schema": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "database": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "tags": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    {
                                                                        "type": "string"
                                                                    }
                                                                ]
                                                            },
                                                            "meta": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "group": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "materialized": {
                                                                "type": "string",
                                                                "default": "view"
                                                            },
                                                            "incremental_strategy": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "batch_size": {
                                                                "default": null
                                                            },
                                                            "lookback": {
                                                                "default": 1
                                                            },
                                                            "begin": {
                                                                "default": null
                                                            },
                                                            "persist_docs": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "post-hook": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "Hook",
                                                                    "properties": {
                                                                        "sql": {
                                                                            "type": "string"
                                                                        },
                                                                        "transaction": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "index": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "sql"
                                                                    ]
                                                                }
                                                            },
                                                            "pre-hook": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "Hook",
                                                                    "properties": {
                                                                        "sql": {
                                                                            "type": "string"
                                                                        },
                                                                        "transaction": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "index": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "sql"
                                                                    ]
                                                                }
                                                            },
                                                            "quoting": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "column_types": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "full_refresh": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "boolean"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "unique_key": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "on_schema_change": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": "ignore"
                                                            },
                                                            "on_configuration_change": {
                                                                "enum": [
                                                                    "apply",
                                                                    "continue",
                                                                    "fail"
                                                                ]
                                                            },
                                                            "grants": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "packages": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "docs": {
                                                                "type": "object",
                                                                "title": "Docs",
                                                                "properties": {
                                                                    "show": {
                                                                        "type": "boolean",
                                                                        "default": true
                                                                    },
                                                                    "node_color": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            "contract": {
                                                                "type": "object",
                                                                "title": "ContractConfig",
                                                                "properties": {
                                                                    "enforced": {
                                                                        "type": "boolean",
                                                                        "default": false
                                                                    },
                                                                    "alias_types": {
                                                                        "type": "boolean",
                                                                        "default": true
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            "event_time": {
                                                                "default": null
                                                            },
                                                            "concurrent_batches": {
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": true
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "database",
                                            "schema",
                                            "alias",
                                            "relation_name",
                                            "resource_type",
                                            "name",
                                            "description",
                                            "compiled_code",
                                            "meta",
                                            "tags",
                                            "config"
                                        ]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "primary_key": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "time_spine": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "TimeSpine",
                                        "properties": {
                                            "standard_granularity_column": {
                                                "type": "string"
                                            },
                                            "custom_granularities": {
                                                "type": "array",
                                                "items": {
                                                    "type": "object",
                                                    "title": "CustomGranularity",
                                                    "properties": {
                                                        "name": {
                                                            "type": "string"
                                                        },
                                                        "column_name": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": ["name"]
                                                }
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "standard_granularity_column"
                                        ]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "freshness": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "ModelFreshness",
                                        "properties": {
                                            "build_after": {
                                                "type": "object",
                                                "title": "ModelBuildAfter",
                                                "properties": {
                                                    "depends_on": {
                                                        "enum": ["all", "any"],
                                                        "default": "any"
                                                    },
                                                    "count": {
                                                        "type": "integer",
                                                        "default": 0
                                                    },
                                                    "period": {
                                                        "enum": [
                                                            "minute",
                                                            "hour",
                                                            "day"
                                                        ],
                                                        "default": "hour"
                                                    }
                                                },
                                                "additionalProperties": true
                                            }
                                        },
                                        "additionalProperties": true
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "SqlOperation",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "sql_operation"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "NodeConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "view"
                                    },
                                    "incremental_strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "batch_size": {
                                        "default": null
                                    },
                                    "lookback": {
                                        "default": 1
                                    },
                                    "begin": {
                                        "default": null
                                    },
                                    "persist_docs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "post-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "pre-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "quoting": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "column_types": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "full_refresh": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "unique_key": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "on_schema_change": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "ignore"
                                    },
                                    "on_configuration_change": {
                                        "enum": ["apply", "continue", "fail"]
                                    },
                                    "grants": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "packages": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "docs": {
                                        "type": "object",
                                        "title": "Docs",
                                        "properties": {
                                            "show": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "node_color": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "contract": {
                                        "type": "object",
                                        "title": "ContractConfig",
                                        "properties": {
                                            "enforced": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "alias_types": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "event_time": {
                                        "default": null
                                    },
                                    "concurrent_batches": {
                                        "default": null
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "GenericTest",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "test"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "TestConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "dbt_test__audit"
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "test"
                                    },
                                    "severity": {
                                        "type": "string",
                                        "default": "ERROR",
                                        "pattern": "^([Ww][Aa][Rr][Nn]|[Ee][Rr][Rr][Oo][Rr])$"
                                    },
                                    "store_failures": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "store_failures_as": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "where": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "limit": {
                                        "anyOf": [
                                            {
                                                "type": "integer"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "fail_calc": {
                                        "type": "string",
                                        "default": "count(*)"
                                    },
                                    "warn_if": {
                                        "type": "string",
                                        "default": "!= 0"
                                    },
                                    "error_if": {
                                        "type": "string",
                                        "default": "!= 0"
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "column_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "file_key_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "attached_node": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "test_metadata": {
                                "type": "object",
                                "title": "TestMetadata",
                                "properties": {
                                    "name": {
                                        "type": "string",
                                        "default": "test"
                                    },
                                    "kwargs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "namespace": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum"
                        ]
                    },
                    {
                        "type": "object",
                        "title": "Snapshot",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "schema": {
                                "type": "string"
                            },
                            "name": {
                                "type": "string"
                            },
                            "resource_type": {
                                "const": "snapshot"
                            },
                            "package_name": {
                                "type": "string"
                            },
                            "path": {
                                "type": "string"
                            },
                            "original_file_path": {
                                "type": "string"
                            },
                            "unique_id": {
                                "type": "string"
                            },
                            "fqn": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "alias": {
                                "type": "string"
                            },
                            "checksum": {
                                "type": "object",
                                "title": "FileHash",
                                "properties": {
                                    "name": {
                                        "type": "string"
                                    },
                                    "checksum": {
                                        "type": "string"
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["name", "checksum"]
                            },
                            "config": {
                                "type": "object",
                                "title": "SnapshotConfig",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "enabled": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "alias": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tags": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "string"
                                            }
                                        ]
                                    },
                                    "meta": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "group": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "materialized": {
                                        "type": "string",
                                        "default": "snapshot"
                                    },
                                    "incremental_strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "batch_size": {
                                        "default": null
                                    },
                                    "lookback": {
                                        "default": 1
                                    },
                                    "begin": {
                                        "default": null
                                    },
                                    "persist_docs": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "post-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "pre-hook": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "Hook",
                                            "properties": {
                                                "sql": {
                                                    "type": "string"
                                                },
                                                "transaction": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "index": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["sql"]
                                        }
                                    },
                                    "quoting": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "column_types": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "full_refresh": {
                                        "anyOf": [
                                            {
                                                "type": "boolean"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "unique_key": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "on_schema_change": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": "ignore"
                                    },
                                    "on_configuration_change": {
                                        "enum": ["apply", "continue", "fail"]
                                    },
                                    "grants": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "packages": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "docs": {
                                        "type": "object",
                                        "title": "Docs",
                                        "properties": {
                                            "show": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "node_color": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "contract": {
                                        "type": "object",
                                        "title": "ContractConfig",
                                        "properties": {
                                            "enforced": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "alias_types": {
                                                "type": "boolean",
                                                "default": true
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "event_time": {
                                        "default": null
                                    },
                                    "concurrent_batches": {
                                        "default": null
                                    },
                                    "strategy": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "target_schema": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "target_database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "updated_at": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "check_cols": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "snapshot_meta_column_names": {
                                        "type": "object",
                                        "title": "SnapshotMetaColumnNames",
                                        "properties": {
                                            "dbt_valid_to": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "dbt_valid_from": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "dbt_scd_id": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "dbt_updated_at": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "dbt_is_deleted": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    "dbt_valid_to_current": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": true
                            },
                            "tags": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "description": {
                                "type": "string",
                                "default": ""
                            },
                            "columns": {
                                "type": "object",
                                "additionalProperties": {
                                    "type": "object",
                                    "title": "ColumnInfo",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "data_type": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ColumnLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "quote": {
                                            "anyOf": [
                                                {
                                                    "type": "boolean"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "_extra": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "granularity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": true,
                                    "required": ["name"]
                                },
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "docs": {
                                "type": "object",
                                "title": "Docs",
                                "properties": {
                                    "show": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "node_color": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "patch_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "build_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "unrendered_config": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "created_at": {
                                "type": "number"
                            },
                            "config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "unrendered_config_call_dict": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "relation_name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "raw_code": {
                                "type": "string",
                                "default": ""
                            },
                            "doc_blocks": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "language": {
                                "type": "string",
                                "default": "sql"
                            },
                            "refs": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "RefArgs",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "package": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "sources": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "depends_on": {
                                "type": "object",
                                "title": "DependsOn",
                                "properties": {
                                    "macros": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    "nodes": {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            "compiled_path": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "compiled": {
                                "type": "boolean",
                                "default": false
                            },
                            "compiled_code": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "extra_ctes_injected": {
                                "type": "boolean",
                                "default": false
                            },
                            "extra_ctes": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "InjectedCTE",
                                    "properties": {
                                        "id": {
                                            "type": "string"
                                        },
                                        "sql": {
                                            "type": "string"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["id", "sql"]
                                }
                            },
                            "_pre_injected_sql": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "contract": {
                                "type": "object",
                                "title": "Contract",
                                "properties": {
                                    "enforced": {
                                        "type": "boolean",
                                        "default": false
                                    },
                                    "alias_types": {
                                        "type": "boolean",
                                        "default": true
                                    },
                                    "checksum": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            "defer_relation": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "DeferRelation",
                                        "properties": {
                                            "database": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "schema": {
                                                "type": "string"
                                            },
                                            "alias": {
                                                "type": "string"
                                            },
                                            "relation_name": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "resource_type": {
                                                "enum": [
                                                    "model",
                                                    "analysis",
                                                    "test",
                                                    "snapshot",
                                                    "operation",
                                                    "seed",
                                                    "rpc",
                                                    "sql_operation",
                                                    "doc",
                                                    "source",
                                                    "macro",
                                                    "exposure",
                                                    "metric",
                                                    "group",
                                                    "saved_query",
                                                    "semantic_model",
                                                    "unit_test",
                                                    "fixture"
                                                ]
                                            },
                                            "name": {
                                                "type": "string"
                                            },
                                            "description": {
                                                "type": "string"
                                            },
                                            "compiled_code": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            },
                                            "meta": {
                                                "type": "object",
                                                "propertyNames": {
                                                    "type": "string"
                                                }
                                            },
                                            "tags": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            "config": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "NodeConfig",
                                                        "properties": {
                                                            "_extra": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "enabled": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "alias": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "schema": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "database": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "tags": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    {
                                                                        "type": "string"
                                                                    }
                                                                ]
                                                            },
                                                            "meta": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "group": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "materialized": {
                                                                "type": "string",
                                                                "default": "view"
                                                            },
                                                            "incremental_strategy": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "batch_size": {
                                                                "default": null
                                                            },
                                                            "lookback": {
                                                                "default": 1
                                                            },
                                                            "begin": {
                                                                "default": null
                                                            },
                                                            "persist_docs": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "post-hook": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "Hook",
                                                                    "properties": {
                                                                        "sql": {
                                                                            "type": "string"
                                                                        },
                                                                        "transaction": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "index": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "sql"
                                                                    ]
                                                                }
                                                            },
                                                            "pre-hook": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "Hook",
                                                                    "properties": {
                                                                        "sql": {
                                                                            "type": "string"
                                                                        },
                                                                        "transaction": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "index": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "sql"
                                                                    ]
                                                                }
                                                            },
                                                            "quoting": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "column_types": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "full_refresh": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "boolean"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "unique_key": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "on_schema_change": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": "ignore"
                                                            },
                                                            "on_configuration_change": {
                                                                "enum": [
                                                                    "apply",
                                                                    "continue",
                                                                    "fail"
                                                                ]
                                                            },
                                                            "grants": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "packages": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "docs": {
                                                                "type": "object",
                                                                "title": "Docs",
                                                                "properties": {
                                                                    "show": {
                                                                        "type": "boolean",
                                                                        "default": true
                                                                    },
                                                                    "node_color": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            "contract": {
                                                                "type": "object",
                                                                "title": "ContractConfig",
                                                                "properties": {
                                                                    "enforced": {
                                                                        "type": "boolean",
                                                                        "default": false
                                                                    },
                                                                    "alias_types": {
                                                                        "type": "boolean",
                                                                        "default": true
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            "event_time": {
                                                                "default": null
                                                            },
                                                            "concurrent_batches": {
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": true
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ]
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "database",
                                            "schema",
                                            "alias",
                                            "relation_name",
                                            "resource_type",
                                            "name",
                                            "description",
                                            "compiled_code",
                                            "meta",
                                            "tags",
                                            "config"
                                        ]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false,
                        "required": [
                            "database",
                            "schema",
                            "name",
                            "resource_type",
                            "package_name",
                            "path",
                            "original_file_path",
                            "unique_id",
                            "fqn",
                            "alias",
                            "checksum",
                            "config"
                        ]
                    }
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "sources": {
            "type": "object",
            "description": "The sources defined in the dbt project and its dependencies",
            "additionalProperties": {
                "type": "object",
                "title": "SourceDefinition",
                "properties": {
                    "database": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ]
                    },
                    "schema": {
                        "type": "string"
                    },
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "source"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "fqn": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "source_name": {
                        "type": "string"
                    },
                    "source_description": {
                        "type": "string"
                    },
                    "loader": {
                        "type": "string"
                    },
                    "identifier": {
                        "type": "string"
                    },
                    "quoting": {
                        "type": "object",
                        "title": "Quoting",
                        "properties": {
                            "database": {
                                "anyOf": [
                                    {
                                        "type": "boolean"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "schema": {
                                "anyOf": [
                                    {
                                        "type": "boolean"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "identifier": {
                                "anyOf": [
                                    {
                                        "type": "boolean"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "column": {
                                "anyOf": [
                                    {
                                        "type": "boolean"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false
                    },
                    "loaded_at_field": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "loaded_at_query": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "freshness": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "FreshnessThreshold",
                                "properties": {
                                    "warn_after": {
                                        "anyOf": [
                                            {
                                                "type": "object",
                                                "title": "Time",
                                                "properties": {
                                                    "count": {
                                                        "anyOf": [
                                                            {
                                                                "type": "integer"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "period": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "minute",
                                                                    "hour",
                                                                    "day"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ]
                                    },
                                    "error_after": {
                                        "anyOf": [
                                            {
                                                "type": "object",
                                                "title": "Time",
                                                "properties": {
                                                    "count": {
                                                        "anyOf": [
                                                            {
                                                                "type": "integer"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "period": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "minute",
                                                                    "hour",
                                                                    "day"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ]
                                    },
                                    "filter": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "external": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "ExternalTable",
                                "properties": {
                                    "_extra": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "location": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "file_format": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "row_format": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "tbl_properties": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "partitions": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            },
                                            {
                                                "type": "array",
                                                "items": {
                                                    "type": "object",
                                                    "title": "ExternalPartition",
                                                    "properties": {
                                                        "_extra": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "name": {
                                                            "type": "string",
                                                            "default": ""
                                                        },
                                                        "description": {
                                                            "type": "string",
                                                            "default": ""
                                                        },
                                                        "data_type": {
                                                            "type": "string",
                                                            "default": ""
                                                        },
                                                        "meta": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        }
                                                    },
                                                    "additionalProperties": true
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": true
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "description": {
                        "type": "string",
                        "default": ""
                    },
                    "columns": {
                        "type": "object",
                        "additionalProperties": {
                            "type": "object",
                            "title": "ColumnInfo",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "description": {
                                    "type": "string",
                                    "default": ""
                                },
                                "meta": {
                                    "type": "object",
                                    "propertyNames": {
                                        "type": "string"
                                    }
                                },
                                "data_type": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "constraints": {
                                    "type": "array",
                                    "items": {
                                        "type": "object",
                                        "title": "ColumnLevelConstraint",
                                        "properties": {
                                            "type": {
                                                "enum": [
                                                    "check",
                                                    "not_null",
                                                    "unique",
                                                    "primary_key",
                                                    "foreign_key",
                                                    "custom"
                                                ]
                                            },
                                            "name": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "expression": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "warn_unenforced": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "warn_unsupported": {
                                                "type": "boolean",
                                                "default": true
                                            },
                                            "to": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "to_columns": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": ["type"]
                                    }
                                },
                                "quote": {
                                    "anyOf": [
                                        {
                                            "type": "boolean"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "tags": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "_extra": {
                                    "type": "object",
                                    "propertyNames": {
                                        "type": "string"
                                    }
                                },
                                "granularity": {
                                    "anyOf": [
                                        {
                                            "enum": [
                                                "nanosecond",
                                                "microsecond",
                                                "millisecond",
                                                "second",
                                                "minute",
                                                "hour",
                                                "day",
                                                "week",
                                                "month",
                                                "quarter",
                                                "year"
                                            ]
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "doc_blocks": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                }
                            },
                            "additionalProperties": true,
                            "required": ["name"]
                        },
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "meta": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "source_meta": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "tags": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "config": {
                        "type": "object",
                        "title": "SourceConfig",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "enabled": {
                                "type": "boolean",
                                "default": true
                            },
                            "event_time": {
                                "default": null
                            }
                        },
                        "additionalProperties": true
                    },
                    "patch_path": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "unrendered_config": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "relation_name": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "created_at": {
                        "type": "number"
                    },
                    "unrendered_database": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "unrendered_schema": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "doc_blocks": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    }
                },
                "additionalProperties": false,
                "required": [
                    "database",
                    "schema",
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "fqn",
                    "source_name",
                    "source_description",
                    "loader",
                    "identifier"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "macros": {
            "type": "object",
            "description": "The macros defined in the dbt project and its dependencies",
            "additionalProperties": {
                "type": "object",
                "title": "Macro",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "macro"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "macro_sql": {
                        "type": "string"
                    },
                    "depends_on": {
                        "type": "object",
                        "title": "MacroDependsOn",
                        "properties": {
                            "macros": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    },
                    "description": {
                        "type": "string",
                        "default": ""
                    },
                    "meta": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "docs": {
                        "type": "object",
                        "title": "Docs",
                        "properties": {
                            "show": {
                                "type": "boolean",
                                "default": true
                            },
                            "node_color": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false
                    },
                    "patch_path": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "arguments": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "MacroArgument",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "type": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "description": {
                                    "type": "string",
                                    "default": ""
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name"]
                        }
                    },
                    "created_at": {
                        "type": "number"
                    },
                    "supported_languages": {
                        "anyOf": [
                            {
                                "type": "array",
                                "items": {
                                    "enum": ["python", "sql"]
                                }
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "macro_sql"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "docs": {
            "type": "object",
            "description": "The docs defined in the dbt project and its dependencies",
            "additionalProperties": {
                "type": "object",
                "title": "Documentation",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "doc"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "block_contents": {
                        "type": "string"
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "block_contents"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "exposures": {
            "type": "object",
            "description": "The exposures defined in the dbt project and its dependencies",
            "additionalProperties": {
                "type": "object",
                "title": "Exposure",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "exposure"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "fqn": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "type": {
                        "enum": [
                            "dashboard",
                            "notebook",
                            "analysis",
                            "ml",
                            "application"
                        ]
                    },
                    "owner": {
                        "type": "object",
                        "title": "Owner",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "email": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": true
                    },
                    "description": {
                        "type": "string",
                        "default": ""
                    },
                    "label": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "maturity": {
                        "anyOf": [
                            {
                                "enum": ["low", "medium", "high"]
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "meta": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "tags": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "config": {
                        "type": "object",
                        "title": "ExposureConfig",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "enabled": {
                                "type": "boolean",
                                "default": true
                            }
                        },
                        "additionalProperties": true
                    },
                    "unrendered_config": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "url": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "depends_on": {
                        "type": "object",
                        "title": "DependsOn",
                        "properties": {
                            "macros": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "nodes": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    },
                    "refs": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "RefArgs",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "package": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "version": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "number"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name"]
                        }
                    },
                    "sources": {
                        "type": "array",
                        "items": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    },
                    "metrics": {
                        "type": "array",
                        "items": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    },
                    "created_at": {
                        "type": "number"
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "fqn",
                    "type",
                    "owner"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "metrics": {
            "type": "object",
            "description": "The metrics defined in the dbt project and its dependencies",
            "additionalProperties": {
                "type": "object",
                "title": "Metric",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "metric"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "fqn": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "description": {
                        "type": "string"
                    },
                    "label": {
                        "type": "string"
                    },
                    "type": {
                        "enum": [
                            "simple",
                            "ratio",
                            "cumulative",
                            "derived",
                            "conversion"
                        ]
                    },
                    "type_params": {
                        "type": "object",
                        "title": "MetricTypeParams",
                        "properties": {
                            "measure": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "MetricInputMeasure",
                                        "properties": {
                                            "name": {
                                                "type": "string"
                                            },
                                            "filter": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "WhereFilterIntersection",
                                                        "properties": {
                                                            "where_filters": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "WhereFilter",
                                                                    "properties": {
                                                                        "where_sql_template": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "where_sql_template"
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "where_filters"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "alias": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "join_to_timespine": {
                                                "type": "boolean",
                                                "default": false
                                            },
                                            "fill_nulls_with": {
                                                "anyOf": [
                                                    {
                                                        "type": "integer"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": ["name"]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "input_measures": {
                                "type": "array",
                                "items": {
                                    "type": "object",
                                    "title": "MetricInputMeasure",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "filter": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "WhereFilterIntersection",
                                                    "properties": {
                                                        "where_filters": {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "object",
                                                                "title": "WhereFilter",
                                                                "properties": {
                                                                    "where_sql_template": {
                                                                        "type": "string"
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "where_sql_template"
                                                                ]
                                                            }
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "where_filters"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "alias": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "join_to_timespine": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "fill_nulls_with": {
                                            "anyOf": [
                                                {
                                                    "type": "integer"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["name"]
                                }
                            },
                            "numerator": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "MetricInput",
                                        "properties": {
                                            "name": {
                                                "type": "string"
                                            },
                                            "filter": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "WhereFilterIntersection",
                                                        "properties": {
                                                            "where_filters": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "WhereFilter",
                                                                    "properties": {
                                                                        "where_sql_template": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "where_sql_template"
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "where_filters"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "alias": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "offset_window": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "MetricTimeWindow",
                                                        "properties": {
                                                            "count": {
                                                                "type": "integer"
                                                            },
                                                            "granularity": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "count",
                                                            "granularity"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "offset_to_grain": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": ["name"]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "denominator": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "MetricInput",
                                        "properties": {
                                            "name": {
                                                "type": "string"
                                            },
                                            "filter": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "WhereFilterIntersection",
                                                        "properties": {
                                                            "where_filters": {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "title": "WhereFilter",
                                                                    "properties": {
                                                                        "where_sql_template": {
                                                                            "type": "string"
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "where_sql_template"
                                                                    ]
                                                                }
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "where_filters"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "alias": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "offset_window": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "MetricTimeWindow",
                                                        "properties": {
                                                            "count": {
                                                                "type": "integer"
                                                            },
                                                            "granularity": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "count",
                                                            "granularity"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "offset_to_grain": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": ["name"]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "expr": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "window": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "MetricTimeWindow",
                                        "properties": {
                                            "count": {
                                                "type": "integer"
                                            },
                                            "granularity": {
                                                "type": "string"
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": ["count", "granularity"]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "grain_to_date": {
                                "anyOf": [
                                    {
                                        "enum": [
                                            "nanosecond",
                                            "microsecond",
                                            "millisecond",
                                            "second",
                                            "minute",
                                            "hour",
                                            "day",
                                            "week",
                                            "month",
                                            "quarter",
                                            "year"
                                        ]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "metrics": {
                                "anyOf": [
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "MetricInput",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "filter": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "WhereFilterIntersection",
                                                            "properties": {
                                                                "where_filters": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "object",
                                                                        "title": "WhereFilter",
                                                                        "properties": {
                                                                            "where_sql_template": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "additionalProperties": false,
                                                                        "required": [
                                                                            "where_sql_template"
                                                                        ]
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "where_filters"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "offset_window": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "MetricTimeWindow",
                                                            "properties": {
                                                                "count": {
                                                                    "type": "integer"
                                                                },
                                                                "granularity": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "count",
                                                                "granularity"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "offset_to_grain": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name"]
                                        }
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "conversion_type_params": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "ConversionTypeParams",
                                        "properties": {
                                            "base_measure": {
                                                "type": "object",
                                                "title": "MetricInputMeasure",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "filter": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "WhereFilterIntersection",
                                                                "properties": {
                                                                    "where_filters": {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "object",
                                                                            "title": "WhereFilter",
                                                                            "properties": {
                                                                                "where_sql_template": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "where_sql_template"
                                                                            ]
                                                                        }
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "where_filters"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "alias": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "join_to_timespine": {
                                                        "type": "boolean",
                                                        "default": false
                                                    },
                                                    "fill_nulls_with": {
                                                        "anyOf": [
                                                            {
                                                                "type": "integer"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            },
                                            "conversion_measure": {
                                                "type": "object",
                                                "title": "MetricInputMeasure",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "filter": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "WhereFilterIntersection",
                                                                "properties": {
                                                                    "where_filters": {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "object",
                                                                            "title": "WhereFilter",
                                                                            "properties": {
                                                                                "where_sql_template": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "where_sql_template"
                                                                            ]
                                                                        }
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "where_filters"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "alias": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "join_to_timespine": {
                                                        "type": "boolean",
                                                        "default": false
                                                    },
                                                    "fill_nulls_with": {
                                                        "anyOf": [
                                                            {
                                                                "type": "integer"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            },
                                            "entity": {
                                                "type": "string"
                                            },
                                            "calculation": {
                                                "enum": [
                                                    "conversions",
                                                    "conversion_rate"
                                                ],
                                                "default": "conversion_rate"
                                            },
                                            "window": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "MetricTimeWindow",
                                                        "properties": {
                                                            "count": {
                                                                "type": "integer"
                                                            },
                                                            "granularity": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "count",
                                                            "granularity"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "constant_properties": {
                                                "anyOf": [
                                                    {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ConstantPropertyInput",
                                                            "properties": {
                                                                "base_property": {
                                                                    "type": "string"
                                                                },
                                                                "conversion_property": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "base_property",
                                                                "conversion_property"
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "base_measure",
                                            "conversion_measure",
                                            "entity"
                                        ]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "cumulative_type_params": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "CumulativeTypeParams",
                                        "properties": {
                                            "window": {
                                                "anyOf": [
                                                    {
                                                        "type": "object",
                                                        "title": "MetricTimeWindow",
                                                        "properties": {
                                                            "count": {
                                                                "type": "integer"
                                                            },
                                                            "granularity": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "count",
                                                            "granularity"
                                                        ]
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "grain_to_date": {
                                                "anyOf": [
                                                    {
                                                        "type": "string"
                                                    },
                                                    {
                                                        "type": "null"
                                                    }
                                                ],
                                                "default": null
                                            },
                                            "period_agg": {
                                                "enum": [
                                                    "first",
                                                    "last",
                                                    "average"
                                                ],
                                                "default": "first"
                                            }
                                        },
                                        "additionalProperties": false
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false
                    },
                    "filter": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "WhereFilterIntersection",
                                "properties": {
                                    "where_filters": {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "title": "WhereFilter",
                                            "properties": {
                                                "where_sql_template": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["where_sql_template"]
                                        }
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["where_filters"]
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "metadata": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "SourceFileMetadata",
                                "properties": {
                                    "repo_file_path": {
                                        "type": "string"
                                    },
                                    "file_slice": {
                                        "type": "object",
                                        "title": "FileSlice",
                                        "properties": {
                                            "filename": {
                                                "type": "string"
                                            },
                                            "content": {
                                                "type": "string"
                                            },
                                            "start_line_number": {
                                                "type": "integer"
                                            },
                                            "end_line_number": {
                                                "type": "integer"
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "filename",
                                            "content",
                                            "start_line_number",
                                            "end_line_number"
                                        ]
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["repo_file_path", "file_slice"]
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "time_granularity": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "meta": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "tags": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "config": {
                        "type": "object",
                        "title": "MetricConfig",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "enabled": {
                                "type": "boolean",
                                "default": true
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": true
                    },
                    "unrendered_config": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "sources": {
                        "type": "array",
                        "items": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    },
                    "depends_on": {
                        "type": "object",
                        "title": "DependsOn",
                        "properties": {
                            "macros": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "nodes": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    },
                    "refs": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "RefArgs",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "package": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "version": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "number"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name"]
                        }
                    },
                    "metrics": {
                        "type": "array",
                        "items": {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    },
                    "created_at": {
                        "type": "number"
                    },
                    "group": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "fqn",
                    "description",
                    "label",
                    "type",
                    "type_params"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "groups": {
            "type": "object",
            "description": "The groups defined in the dbt project",
            "additionalProperties": {
                "type": "object",
                "title": "Group",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "group"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "owner": {
                        "type": "object",
                        "title": "Owner",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "email": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "name": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": true
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "owner"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "selectors": {
            "type": "object",
            "description": "The selectors defined in selectors.yml",
            "propertyNames": {
                "type": "string"
            }
        },
        "disabled": {
            "description": "A mapping of the disabled nodes in the target",
            "anyOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "anyOf": [
                                {
                                    "type": "object",
                                    "title": "Seed",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "seed"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "SeedConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "seed"
                                                },
                                                "incremental_strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "batch_size": {
                                                    "default": null
                                                },
                                                "lookback": {
                                                    "default": 1
                                                },
                                                "begin": {
                                                    "default": null
                                                },
                                                "persist_docs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "post-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "pre-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "quoting": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "column_types": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "full_refresh": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "unique_key": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "on_schema_change": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "ignore"
                                                },
                                                "on_configuration_change": {
                                                    "enum": [
                                                        "apply",
                                                        "continue",
                                                        "fail"
                                                    ]
                                                },
                                                "grants": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "packages": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "docs": {
                                                    "type": "object",
                                                    "title": "Docs",
                                                    "properties": {
                                                        "show": {
                                                            "type": "boolean",
                                                            "default": true
                                                        },
                                                        "node_color": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "contract": {
                                                    "type": "object",
                                                    "title": "ContractConfig",
                                                    "properties": {
                                                        "enforced": {
                                                            "type": "boolean",
                                                            "default": false
                                                        },
                                                        "alias_types": {
                                                            "type": "boolean",
                                                            "default": true
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "event_time": {
                                                    "default": null
                                                },
                                                "concurrent_batches": {
                                                    "default": null
                                                },
                                                "delimiter": {
                                                    "type": "string",
                                                    "default": ","
                                                },
                                                "quote_columns": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "root_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "MacroDependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "defer_relation": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "DeferRelation",
                                                    "properties": {
                                                        "database": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "schema": {
                                                            "type": "string"
                                                        },
                                                        "alias": {
                                                            "type": "string"
                                                        },
                                                        "relation_name": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "resource_type": {
                                                            "enum": [
                                                                "model",
                                                                "analysis",
                                                                "test",
                                                                "snapshot",
                                                                "operation",
                                                                "seed",
                                                                "rpc",
                                                                "sql_operation",
                                                                "doc",
                                                                "source",
                                                                "macro",
                                                                "exposure",
                                                                "metric",
                                                                "group",
                                                                "saved_query",
                                                                "semantic_model",
                                                                "unit_test",
                                                                "fixture"
                                                            ]
                                                        },
                                                        "name": {
                                                            "type": "string"
                                                        },
                                                        "description": {
                                                            "type": "string"
                                                        },
                                                        "compiled_code": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "meta": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "tags": {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "config": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "object",
                                                                    "title": "NodeConfig",
                                                                    "properties": {
                                                                        "_extra": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "enabled": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "alias": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "schema": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "database": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "tags": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "type": "string"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "meta": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "group": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "materialized": {
                                                                            "type": "string",
                                                                            "default": "view"
                                                                        },
                                                                        "incremental_strategy": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "batch_size": {
                                                                            "default": null
                                                                        },
                                                                        "lookback": {
                                                                            "default": 1
                                                                        },
                                                                        "begin": {
                                                                            "default": null
                                                                        },
                                                                        "persist_docs": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "post-hook": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "Hook",
                                                                                "properties": {
                                                                                    "sql": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "transaction": {
                                                                                        "type": "boolean",
                                                                                        "default": true
                                                                                    },
                                                                                    "index": {
                                                                                        "anyOf": [
                                                                                            {
                                                                                                "type": "integer"
                                                                                            },
                                                                                            {
                                                                                                "type": "null"
                                                                                            }
                                                                                        ],
                                                                                        "default": null
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "sql"
                                                                                ]
                                                                            }
                                                                        },
                                                                        "pre-hook": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "Hook",
                                                                                "properties": {
                                                                                    "sql": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "transaction": {
                                                                                        "type": "boolean",
                                                                                        "default": true
                                                                                    },
                                                                                    "index": {
                                                                                        "anyOf": [
                                                                                            {
                                                                                                "type": "integer"
                                                                                            },
                                                                                            {
                                                                                                "type": "null"
                                                                                            }
                                                                                        ],
                                                                                        "default": null
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "sql"
                                                                                ]
                                                                            }
                                                                        },
                                                                        "quoting": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "column_types": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "full_refresh": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "boolean"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "unique_key": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "on_schema_change": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": "ignore"
                                                                        },
                                                                        "on_configuration_change": {
                                                                            "enum": [
                                                                                "apply",
                                                                                "continue",
                                                                                "fail"
                                                                            ]
                                                                        },
                                                                        "grants": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "packages": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "docs": {
                                                                            "type": "object",
                                                                            "title": "Docs",
                                                                            "properties": {
                                                                                "show": {
                                                                                    "type": "boolean",
                                                                                    "default": true
                                                                                },
                                                                                "node_color": {
                                                                                    "anyOf": [
                                                                                        {
                                                                                            "type": "string"
                                                                                        },
                                                                                        {
                                                                                            "type": "null"
                                                                                        }
                                                                                    ],
                                                                                    "default": null
                                                                                }
                                                                            },
                                                                            "additionalProperties": false
                                                                        },
                                                                        "contract": {
                                                                            "type": "object",
                                                                            "title": "ContractConfig",
                                                                            "properties": {
                                                                                "enforced": {
                                                                                    "type": "boolean",
                                                                                    "default": false
                                                                                },
                                                                                "alias_types": {
                                                                                    "type": "boolean",
                                                                                    "default": true
                                                                                }
                                                                            },
                                                                            "additionalProperties": false
                                                                        },
                                                                        "event_time": {
                                                                            "default": null
                                                                        },
                                                                        "concurrent_batches": {
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": true
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "database",
                                                        "schema",
                                                        "alias",
                                                        "relation_name",
                                                        "resource_type",
                                                        "name",
                                                        "description",
                                                        "compiled_code",
                                                        "meta",
                                                        "tags",
                                                        "config"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "Analysis",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "analysis"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "NodeConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "view"
                                                },
                                                "incremental_strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "batch_size": {
                                                    "default": null
                                                },
                                                "lookback": {
                                                    "default": 1
                                                },
                                                "begin": {
                                                    "default": null
                                                },
                                                "persist_docs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "post-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "pre-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "quoting": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "column_types": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "full_refresh": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "unique_key": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "on_schema_change": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "ignore"
                                                },
                                                "on_configuration_change": {
                                                    "enum": [
                                                        "apply",
                                                        "continue",
                                                        "fail"
                                                    ]
                                                },
                                                "grants": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "packages": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "docs": {
                                                    "type": "object",
                                                    "title": "Docs",
                                                    "properties": {
                                                        "show": {
                                                            "type": "boolean",
                                                            "default": true
                                                        },
                                                        "node_color": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "contract": {
                                                    "type": "object",
                                                    "title": "ContractConfig",
                                                    "properties": {
                                                        "enforced": {
                                                            "type": "boolean",
                                                            "default": false
                                                        },
                                                        "alias_types": {
                                                            "type": "boolean",
                                                            "default": true
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "event_time": {
                                                    "default": null
                                                },
                                                "concurrent_batches": {
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "SingularTest",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "test"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "TestConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "dbt_test__audit"
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "test"
                                                },
                                                "severity": {
                                                    "type": "string",
                                                    "default": "ERROR",
                                                    "pattern": "^([Ww][Aa][Rr][Nn]|[Ee][Rr][Rr][Oo][Rr])$"
                                                },
                                                "store_failures": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "store_failures_as": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "where": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "limit": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "fail_calc": {
                                                    "type": "string",
                                                    "default": "count(*)"
                                                },
                                                "warn_if": {
                                                    "type": "string",
                                                    "default": "!= 0"
                                                },
                                                "error_if": {
                                                    "type": "string",
                                                    "default": "!= 0"
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "HookNode",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "operation"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "NodeConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "view"
                                                },
                                                "incremental_strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "batch_size": {
                                                    "default": null
                                                },
                                                "lookback": {
                                                    "default": 1
                                                },
                                                "begin": {
                                                    "default": null
                                                },
                                                "persist_docs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "post-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "pre-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "quoting": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "column_types": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "full_refresh": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "unique_key": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "on_schema_change": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "ignore"
                                                },
                                                "on_configuration_change": {
                                                    "enum": [
                                                        "apply",
                                                        "continue",
                                                        "fail"
                                                    ]
                                                },
                                                "grants": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "packages": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "docs": {
                                                    "type": "object",
                                                    "title": "Docs",
                                                    "properties": {
                                                        "show": {
                                                            "type": "boolean",
                                                            "default": true
                                                        },
                                                        "node_color": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "contract": {
                                                    "type": "object",
                                                    "title": "ContractConfig",
                                                    "properties": {
                                                        "enforced": {
                                                            "type": "boolean",
                                                            "default": false
                                                        },
                                                        "alias_types": {
                                                            "type": "boolean",
                                                            "default": true
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "event_time": {
                                                    "default": null
                                                },
                                                "concurrent_batches": {
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "index": {
                                            "anyOf": [
                                                {
                                                    "type": "integer"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "Model",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "model"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "ModelConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "view"
                                                },
                                                "incremental_strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "batch_size": {
                                                    "default": null
                                                },
                                                "lookback": {
                                                    "default": 1
                                                },
                                                "begin": {
                                                    "default": null
                                                },
                                                "persist_docs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "post-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "pre-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "quoting": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "column_types": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "full_refresh": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "unique_key": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "on_schema_change": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "ignore"
                                                },
                                                "on_configuration_change": {
                                                    "enum": [
                                                        "apply",
                                                        "continue",
                                                        "fail"
                                                    ]
                                                },
                                                "grants": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "packages": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "docs": {
                                                    "type": "object",
                                                    "title": "Docs",
                                                    "properties": {
                                                        "show": {
                                                            "type": "boolean",
                                                            "default": true
                                                        },
                                                        "node_color": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "contract": {
                                                    "type": "object",
                                                    "title": "ContractConfig",
                                                    "properties": {
                                                        "enforced": {
                                                            "type": "boolean",
                                                            "default": false
                                                        },
                                                        "alias_types": {
                                                            "type": "boolean",
                                                            "default": true
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "event_time": {
                                                    "default": null
                                                },
                                                "concurrent_batches": {
                                                    "default": null
                                                },
                                                "access": {
                                                    "enum": [
                                                        "private",
                                                        "protected",
                                                        "public"
                                                    ],
                                                    "default": "protected"
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "access": {
                                            "enum": [
                                                "private",
                                                "protected",
                                                "public"
                                            ],
                                            "default": "protected"
                                        },
                                        "constraints": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "ModelLevelConstraint",
                                                "properties": {
                                                    "type": {
                                                        "enum": [
                                                            "check",
                                                            "not_null",
                                                            "unique",
                                                            "primary_key",
                                                            "foreign_key",
                                                            "custom"
                                                        ]
                                                    },
                                                    "name": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expression": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "warn_unenforced": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "warn_unsupported": {
                                                        "type": "boolean",
                                                        "default": true
                                                    },
                                                    "to": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "to_columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "columns": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["type"]
                                            }
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "latest_version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "deprecation_date": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "defer_relation": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "DeferRelation",
                                                    "properties": {
                                                        "database": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "schema": {
                                                            "type": "string"
                                                        },
                                                        "alias": {
                                                            "type": "string"
                                                        },
                                                        "relation_name": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "resource_type": {
                                                            "enum": [
                                                                "model",
                                                                "analysis",
                                                                "test",
                                                                "snapshot",
                                                                "operation",
                                                                "seed",
                                                                "rpc",
                                                                "sql_operation",
                                                                "doc",
                                                                "source",
                                                                "macro",
                                                                "exposure",
                                                                "metric",
                                                                "group",
                                                                "saved_query",
                                                                "semantic_model",
                                                                "unit_test",
                                                                "fixture"
                                                            ]
                                                        },
                                                        "name": {
                                                            "type": "string"
                                                        },
                                                        "description": {
                                                            "type": "string"
                                                        },
                                                        "compiled_code": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "meta": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "tags": {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "config": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "object",
                                                                    "title": "NodeConfig",
                                                                    "properties": {
                                                                        "_extra": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "enabled": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "alias": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "schema": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "database": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "tags": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "type": "string"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "meta": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "group": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "materialized": {
                                                                            "type": "string",
                                                                            "default": "view"
                                                                        },
                                                                        "incremental_strategy": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "batch_size": {
                                                                            "default": null
                                                                        },
                                                                        "lookback": {
                                                                            "default": 1
                                                                        },
                                                                        "begin": {
                                                                            "default": null
                                                                        },
                                                                        "persist_docs": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "post-hook": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "Hook",
                                                                                "properties": {
                                                                                    "sql": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "transaction": {
                                                                                        "type": "boolean",
                                                                                        "default": true
                                                                                    },
                                                                                    "index": {
                                                                                        "anyOf": [
                                                                                            {
                                                                                                "type": "integer"
                                                                                            },
                                                                                            {
                                                                                                "type": "null"
                                                                                            }
                                                                                        ],
                                                                                        "default": null
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "sql"
                                                                                ]
                                                                            }
                                                                        },
                                                                        "pre-hook": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "Hook",
                                                                                "properties": {
                                                                                    "sql": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "transaction": {
                                                                                        "type": "boolean",
                                                                                        "default": true
                                                                                    },
                                                                                    "index": {
                                                                                        "anyOf": [
                                                                                            {
                                                                                                "type": "integer"
                                                                                            },
                                                                                            {
                                                                                                "type": "null"
                                                                                            }
                                                                                        ],
                                                                                        "default": null
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "sql"
                                                                                ]
                                                                            }
                                                                        },
                                                                        "quoting": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "column_types": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "full_refresh": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "boolean"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "unique_key": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "on_schema_change": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": "ignore"
                                                                        },
                                                                        "on_configuration_change": {
                                                                            "enum": [
                                                                                "apply",
                                                                                "continue",
                                                                                "fail"
                                                                            ]
                                                                        },
                                                                        "grants": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "packages": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "docs": {
                                                                            "type": "object",
                                                                            "title": "Docs",
                                                                            "properties": {
                                                                                "show": {
                                                                                    "type": "boolean",
                                                                                    "default": true
                                                                                },
                                                                                "node_color": {
                                                                                    "anyOf": [
                                                                                        {
                                                                                            "type": "string"
                                                                                        },
                                                                                        {
                                                                                            "type": "null"
                                                                                        }
                                                                                    ],
                                                                                    "default": null
                                                                                }
                                                                            },
                                                                            "additionalProperties": false
                                                                        },
                                                                        "contract": {
                                                                            "type": "object",
                                                                            "title": "ContractConfig",
                                                                            "properties": {
                                                                                "enforced": {
                                                                                    "type": "boolean",
                                                                                    "default": false
                                                                                },
                                                                                "alias_types": {
                                                                                    "type": "boolean",
                                                                                    "default": true
                                                                                }
                                                                            },
                                                                            "additionalProperties": false
                                                                        },
                                                                        "event_time": {
                                                                            "default": null
                                                                        },
                                                                        "concurrent_batches": {
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": true
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "database",
                                                        "schema",
                                                        "alias",
                                                        "relation_name",
                                                        "resource_type",
                                                        "name",
                                                        "description",
                                                        "compiled_code",
                                                        "meta",
                                                        "tags",
                                                        "config"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "primary_key": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "time_spine": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "TimeSpine",
                                                    "properties": {
                                                        "standard_granularity_column": {
                                                            "type": "string"
                                                        },
                                                        "custom_granularities": {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "object",
                                                                "title": "CustomGranularity",
                                                                "properties": {
                                                                    "name": {
                                                                        "type": "string"
                                                                    },
                                                                    "column_name": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "name"
                                                                ]
                                                            }
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "standard_granularity_column"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "freshness": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "ModelFreshness",
                                                    "properties": {
                                                        "build_after": {
                                                            "type": "object",
                                                            "title": "ModelBuildAfter",
                                                            "properties": {
                                                                "depends_on": {
                                                                    "enum": [
                                                                        "all",
                                                                        "any"
                                                                    ],
                                                                    "default": "any"
                                                                },
                                                                "count": {
                                                                    "type": "integer",
                                                                    "default": 0
                                                                },
                                                                "period": {
                                                                    "enum": [
                                                                        "minute",
                                                                        "hour",
                                                                        "day"
                                                                    ],
                                                                    "default": "hour"
                                                                }
                                                            },
                                                            "additionalProperties": true
                                                        }
                                                    },
                                                    "additionalProperties": true
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "SqlOperation",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "sql_operation"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "NodeConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "view"
                                                },
                                                "incremental_strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "batch_size": {
                                                    "default": null
                                                },
                                                "lookback": {
                                                    "default": 1
                                                },
                                                "begin": {
                                                    "default": null
                                                },
                                                "persist_docs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "post-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "pre-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "quoting": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "column_types": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "full_refresh": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "unique_key": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "on_schema_change": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "ignore"
                                                },
                                                "on_configuration_change": {
                                                    "enum": [
                                                        "apply",
                                                        "continue",
                                                        "fail"
                                                    ]
                                                },
                                                "grants": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "packages": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "docs": {
                                                    "type": "object",
                                                    "title": "Docs",
                                                    "properties": {
                                                        "show": {
                                                            "type": "boolean",
                                                            "default": true
                                                        },
                                                        "node_color": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "contract": {
                                                    "type": "object",
                                                    "title": "ContractConfig",
                                                    "properties": {
                                                        "enforced": {
                                                            "type": "boolean",
                                                            "default": false
                                                        },
                                                        "alias_types": {
                                                            "type": "boolean",
                                                            "default": true
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "event_time": {
                                                    "default": null
                                                },
                                                "concurrent_batches": {
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "GenericTest",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "test"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "TestConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "dbt_test__audit"
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "test"
                                                },
                                                "severity": {
                                                    "type": "string",
                                                    "default": "ERROR",
                                                    "pattern": "^([Ww][Aa][Rr][Nn]|[Ee][Rr][Rr][Oo][Rr])$"
                                                },
                                                "store_failures": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "store_failures_as": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "where": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "limit": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "fail_calc": {
                                                    "type": "string",
                                                    "default": "count(*)"
                                                },
                                                "warn_if": {
                                                    "type": "string",
                                                    "default": "!= 0"
                                                },
                                                "error_if": {
                                                    "type": "string",
                                                    "default": "!= 0"
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "column_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "file_key_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "attached_node": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "test_metadata": {
                                            "type": "object",
                                            "title": "TestMetadata",
                                            "properties": {
                                                "name": {
                                                    "type": "string",
                                                    "default": "test"
                                                },
                                                "kwargs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "namespace": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "Snapshot",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "snapshot"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "alias": {
                                            "type": "string"
                                        },
                                        "checksum": {
                                            "type": "object",
                                            "title": "FileHash",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "checksum": {
                                                    "type": "string"
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["name", "checksum"]
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "SnapshotConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "alias": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "materialized": {
                                                    "type": "string",
                                                    "default": "snapshot"
                                                },
                                                "incremental_strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "batch_size": {
                                                    "default": null
                                                },
                                                "lookback": {
                                                    "default": 1
                                                },
                                                "begin": {
                                                    "default": null
                                                },
                                                "persist_docs": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "post-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "pre-hook": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "Hook",
                                                        "properties": {
                                                            "sql": {
                                                                "type": "string"
                                                            },
                                                            "transaction": {
                                                                "type": "boolean",
                                                                "default": true
                                                            },
                                                            "index": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["sql"]
                                                    }
                                                },
                                                "quoting": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "column_types": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "full_refresh": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "unique_key": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "on_schema_change": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": "ignore"
                                                },
                                                "on_configuration_change": {
                                                    "enum": [
                                                        "apply",
                                                        "continue",
                                                        "fail"
                                                    ]
                                                },
                                                "grants": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "packages": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "docs": {
                                                    "type": "object",
                                                    "title": "Docs",
                                                    "properties": {
                                                        "show": {
                                                            "type": "boolean",
                                                            "default": true
                                                        },
                                                        "node_color": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "contract": {
                                                    "type": "object",
                                                    "title": "ContractConfig",
                                                    "properties": {
                                                        "enforced": {
                                                            "type": "boolean",
                                                            "default": false
                                                        },
                                                        "alias_types": {
                                                            "type": "boolean",
                                                            "default": true
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "event_time": {
                                                    "default": null
                                                },
                                                "concurrent_batches": {
                                                    "default": null
                                                },
                                                "strategy": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "target_schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "target_database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "updated_at": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "check_cols": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "snapshot_meta_column_names": {
                                                    "type": "object",
                                                    "title": "SnapshotMetaColumnNames",
                                                    "properties": {
                                                        "dbt_valid_to": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "dbt_valid_from": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "dbt_scd_id": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "dbt_updated_at": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "dbt_is_deleted": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                "dbt_valid_to_current": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "docs": {
                                            "type": "object",
                                            "title": "Docs",
                                            "properties": {
                                                "show": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "node_color": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "build_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "unrendered_config_call_dict": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "raw_code": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "language": {
                                            "type": "string",
                                            "default": "sql"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "compiled_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "compiled": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "compiled_code": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "extra_ctes_injected": {
                                            "type": "boolean",
                                            "default": false
                                        },
                                        "extra_ctes": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "InjectedCTE",
                                                "properties": {
                                                    "id": {
                                                        "type": "string"
                                                    },
                                                    "sql": {
                                                        "type": "string"
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["id", "sql"]
                                            }
                                        },
                                        "_pre_injected_sql": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "contract": {
                                            "type": "object",
                                            "title": "Contract",
                                            "properties": {
                                                "enforced": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "alias_types": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "checksum": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "defer_relation": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "DeferRelation",
                                                    "properties": {
                                                        "database": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "schema": {
                                                            "type": "string"
                                                        },
                                                        "alias": {
                                                            "type": "string"
                                                        },
                                                        "relation_name": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "resource_type": {
                                                            "enum": [
                                                                "model",
                                                                "analysis",
                                                                "test",
                                                                "snapshot",
                                                                "operation",
                                                                "seed",
                                                                "rpc",
                                                                "sql_operation",
                                                                "doc",
                                                                "source",
                                                                "macro",
                                                                "exposure",
                                                                "metric",
                                                                "group",
                                                                "saved_query",
                                                                "semantic_model",
                                                                "unit_test",
                                                                "fixture"
                                                            ]
                                                        },
                                                        "name": {
                                                            "type": "string"
                                                        },
                                                        "description": {
                                                            "type": "string"
                                                        },
                                                        "compiled_code": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "meta": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "tags": {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "config": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "object",
                                                                    "title": "NodeConfig",
                                                                    "properties": {
                                                                        "_extra": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "enabled": {
                                                                            "type": "boolean",
                                                                            "default": true
                                                                        },
                                                                        "alias": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "schema": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "database": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "tags": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "type": "string"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "meta": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "group": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "materialized": {
                                                                            "type": "string",
                                                                            "default": "view"
                                                                        },
                                                                        "incremental_strategy": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "batch_size": {
                                                                            "default": null
                                                                        },
                                                                        "lookback": {
                                                                            "default": 1
                                                                        },
                                                                        "begin": {
                                                                            "default": null
                                                                        },
                                                                        "persist_docs": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "post-hook": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "Hook",
                                                                                "properties": {
                                                                                    "sql": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "transaction": {
                                                                                        "type": "boolean",
                                                                                        "default": true
                                                                                    },
                                                                                    "index": {
                                                                                        "anyOf": [
                                                                                            {
                                                                                                "type": "integer"
                                                                                            },
                                                                                            {
                                                                                                "type": "null"
                                                                                            }
                                                                                        ],
                                                                                        "default": null
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "sql"
                                                                                ]
                                                                            }
                                                                        },
                                                                        "pre-hook": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "Hook",
                                                                                "properties": {
                                                                                    "sql": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "transaction": {
                                                                                        "type": "boolean",
                                                                                        "default": true
                                                                                    },
                                                                                    "index": {
                                                                                        "anyOf": [
                                                                                            {
                                                                                                "type": "integer"
                                                                                            },
                                                                                            {
                                                                                                "type": "null"
                                                                                            }
                                                                                        ],
                                                                                        "default": null
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "sql"
                                                                                ]
                                                                            }
                                                                        },
                                                                        "quoting": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "column_types": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "full_refresh": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "boolean"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "unique_key": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "on_schema_change": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": "ignore"
                                                                        },
                                                                        "on_configuration_change": {
                                                                            "enum": [
                                                                                "apply",
                                                                                "continue",
                                                                                "fail"
                                                                            ]
                                                                        },
                                                                        "grants": {
                                                                            "type": "object",
                                                                            "propertyNames": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "packages": {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "docs": {
                                                                            "type": "object",
                                                                            "title": "Docs",
                                                                            "properties": {
                                                                                "show": {
                                                                                    "type": "boolean",
                                                                                    "default": true
                                                                                },
                                                                                "node_color": {
                                                                                    "anyOf": [
                                                                                        {
                                                                                            "type": "string"
                                                                                        },
                                                                                        {
                                                                                            "type": "null"
                                                                                        }
                                                                                    ],
                                                                                    "default": null
                                                                                }
                                                                            },
                                                                            "additionalProperties": false
                                                                        },
                                                                        "contract": {
                                                                            "type": "object",
                                                                            "title": "ContractConfig",
                                                                            "properties": {
                                                                                "enforced": {
                                                                                    "type": "boolean",
                                                                                    "default": false
                                                                                },
                                                                                "alias_types": {
                                                                                    "type": "boolean",
                                                                                    "default": true
                                                                                }
                                                                            },
                                                                            "additionalProperties": false
                                                                        },
                                                                        "event_time": {
                                                                            "default": null
                                                                        },
                                                                        "concurrent_batches": {
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": true
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "database",
                                                        "schema",
                                                        "alias",
                                                        "relation_name",
                                                        "resource_type",
                                                        "name",
                                                        "description",
                                                        "compiled_code",
                                                        "meta",
                                                        "tags",
                                                        "config"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "alias",
                                        "checksum",
                                        "config"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "SourceDefinition",
                                    "properties": {
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "schema": {
                                            "type": "string"
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "source"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "source_name": {
                                            "type": "string"
                                        },
                                        "source_description": {
                                            "type": "string"
                                        },
                                        "loader": {
                                            "type": "string"
                                        },
                                        "identifier": {
                                            "type": "string"
                                        },
                                        "quoting": {
                                            "type": "object",
                                            "title": "Quoting",
                                            "properties": {
                                                "database": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "identifier": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "column": {
                                                    "anyOf": [
                                                        {
                                                            "type": "boolean"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "loaded_at_field": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "loaded_at_query": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "freshness": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "FreshnessThreshold",
                                                    "properties": {
                                                        "warn_after": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "object",
                                                                    "title": "Time",
                                                                    "properties": {
                                                                        "count": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "period": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "enum": [
                                                                                        "minute",
                                                                                        "hour",
                                                                                        "day"
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "error_after": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "object",
                                                                    "title": "Time",
                                                                    "properties": {
                                                                        "count": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "period": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "enum": [
                                                                                        "minute",
                                                                                        "hour",
                                                                                        "day"
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ]
                                                        },
                                                        "filter": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "external": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "ExternalTable",
                                                    "properties": {
                                                        "_extra": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "location": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "file_format": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "row_format": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "tbl_properties": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "partitions": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                },
                                                                {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "object",
                                                                        "title": "ExternalPartition",
                                                                        "properties": {
                                                                            "_extra": {
                                                                                "type": "object",
                                                                                "propertyNames": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "name": {
                                                                                "type": "string",
                                                                                "default": ""
                                                                            },
                                                                            "description": {
                                                                                "type": "string",
                                                                                "default": ""
                                                                            },
                                                                            "data_type": {
                                                                                "type": "string",
                                                                                "default": ""
                                                                            },
                                                                            "meta": {
                                                                                "type": "object",
                                                                                "propertyNames": {
                                                                                    "type": "string"
                                                                                }
                                                                            }
                                                                        },
                                                                        "additionalProperties": true
                                                                    }
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": true
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "columns": {
                                            "type": "object",
                                            "additionalProperties": {
                                                "type": "object",
                                                "title": "ColumnInfo",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "description": {
                                                        "type": "string",
                                                        "default": ""
                                                    },
                                                    "meta": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "data_type": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "constraints": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "object",
                                                            "title": "ColumnLevelConstraint",
                                                            "properties": {
                                                                "type": {
                                                                    "enum": [
                                                                        "check",
                                                                        "not_null",
                                                                        "unique",
                                                                        "primary_key",
                                                                        "foreign_key",
                                                                        "custom"
                                                                    ]
                                                                },
                                                                "name": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "expression": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "warn_unenforced": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "warn_unsupported": {
                                                                    "type": "boolean",
                                                                    "default": true
                                                                },
                                                                "to": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "to_columns": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["type"]
                                                        }
                                                    },
                                                    "quote": {
                                                        "anyOf": [
                                                            {
                                                                "type": "boolean"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "tags": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "_extra": {
                                                        "type": "object",
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "granularity": {
                                                        "anyOf": [
                                                            {
                                                                "enum": [
                                                                    "nanosecond",
                                                                    "microsecond",
                                                                    "millisecond",
                                                                    "second",
                                                                    "minute",
                                                                    "hour",
                                                                    "day",
                                                                    "week",
                                                                    "month",
                                                                    "quarter",
                                                                    "year"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "doc_blocks": {
                                                        "type": "array",
                                                        "items": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": true,
                                                "required": ["name"]
                                            },
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "source_meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "SourceConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "event_time": {
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "patch_path": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "relation_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "unrendered_database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "unrendered_schema": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "doc_blocks": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "database",
                                        "schema",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "source_name",
                                        "source_description",
                                        "loader",
                                        "identifier"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "Exposure",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "exposure"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "type": {
                                            "enum": [
                                                "dashboard",
                                                "notebook",
                                                "analysis",
                                                "ml",
                                                "application"
                                            ]
                                        },
                                        "owner": {
                                            "type": "object",
                                            "title": "Owner",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "email": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "name": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "label": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "maturity": {
                                            "anyOf": [
                                                {
                                                    "enum": [
                                                        "low",
                                                        "medium",
                                                        "high"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "ExposureConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "url": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "type",
                                        "owner"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "Metric",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "metric"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string"
                                        },
                                        "label": {
                                            "type": "string"
                                        },
                                        "type": {
                                            "enum": [
                                                "simple",
                                                "ratio",
                                                "cumulative",
                                                "derived",
                                                "conversion"
                                            ]
                                        },
                                        "type_params": {
                                            "type": "object",
                                            "title": "MetricTypeParams",
                                            "properties": {
                                                "measure": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "MetricInputMeasure",
                                                            "properties": {
                                                                "name": {
                                                                    "type": "string"
                                                                },
                                                                "filter": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "WhereFilterIntersection",
                                                                            "properties": {
                                                                                "where_filters": {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "object",
                                                                                        "title": "WhereFilter",
                                                                                        "properties": {
                                                                                            "where_sql_template": {
                                                                                                "type": "string"
                                                                                            }
                                                                                        },
                                                                                        "additionalProperties": false,
                                                                                        "required": [
                                                                                            "where_sql_template"
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "where_filters"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "alias": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "join_to_timespine": {
                                                                    "type": "boolean",
                                                                    "default": false
                                                                },
                                                                "fill_nulls_with": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "integer"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["name"]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "input_measures": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "title": "MetricInputMeasure",
                                                        "properties": {
                                                            "name": {
                                                                "type": "string"
                                                            },
                                                            "filter": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "object",
                                                                        "title": "WhereFilterIntersection",
                                                                        "properties": {
                                                                            "where_filters": {
                                                                                "type": "array",
                                                                                "items": {
                                                                                    "type": "object",
                                                                                    "title": "WhereFilter",
                                                                                    "properties": {
                                                                                        "where_sql_template": {
                                                                                            "type": "string"
                                                                                        }
                                                                                    },
                                                                                    "additionalProperties": false,
                                                                                    "required": [
                                                                                        "where_sql_template"
                                                                                    ]
                                                                                }
                                                                            }
                                                                        },
                                                                        "additionalProperties": false,
                                                                        "required": [
                                                                            "where_filters"
                                                                        ]
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "alias": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "join_to_timespine": {
                                                                "type": "boolean",
                                                                "default": false
                                                            },
                                                            "fill_nulls_with": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "integer"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": ["name"]
                                                    }
                                                },
                                                "numerator": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "MetricInput",
                                                            "properties": {
                                                                "name": {
                                                                    "type": "string"
                                                                },
                                                                "filter": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "WhereFilterIntersection",
                                                                            "properties": {
                                                                                "where_filters": {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "object",
                                                                                        "title": "WhereFilter",
                                                                                        "properties": {
                                                                                            "where_sql_template": {
                                                                                                "type": "string"
                                                                                            }
                                                                                        },
                                                                                        "additionalProperties": false,
                                                                                        "required": [
                                                                                            "where_sql_template"
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "where_filters"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "alias": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "offset_window": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "MetricTimeWindow",
                                                                            "properties": {
                                                                                "count": {
                                                                                    "type": "integer"
                                                                                },
                                                                                "granularity": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "count",
                                                                                "granularity"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "offset_to_grain": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["name"]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "denominator": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "MetricInput",
                                                            "properties": {
                                                                "name": {
                                                                    "type": "string"
                                                                },
                                                                "filter": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "WhereFilterIntersection",
                                                                            "properties": {
                                                                                "where_filters": {
                                                                                    "type": "array",
                                                                                    "items": {
                                                                                        "type": "object",
                                                                                        "title": "WhereFilter",
                                                                                        "properties": {
                                                                                            "where_sql_template": {
                                                                                                "type": "string"
                                                                                            }
                                                                                        },
                                                                                        "additionalProperties": false,
                                                                                        "required": [
                                                                                            "where_sql_template"
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "where_filters"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "alias": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "offset_window": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "MetricTimeWindow",
                                                                            "properties": {
                                                                                "count": {
                                                                                    "type": "integer"
                                                                                },
                                                                                "granularity": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "count",
                                                                                "granularity"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "offset_to_grain": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": ["name"]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "expr": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "window": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "MetricTimeWindow",
                                                            "properties": {
                                                                "count": {
                                                                    "type": "integer"
                                                                },
                                                                "granularity": {
                                                                    "type": "string"
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "count",
                                                                "granularity"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "grain_to_date": {
                                                    "anyOf": [
                                                        {
                                                            "enum": [
                                                                "nanosecond",
                                                                "microsecond",
                                                                "millisecond",
                                                                "second",
                                                                "minute",
                                                                "hour",
                                                                "day",
                                                                "week",
                                                                "month",
                                                                "quarter",
                                                                "year"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "metrics": {
                                                    "anyOf": [
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "object",
                                                                "title": "MetricInput",
                                                                "properties": {
                                                                    "name": {
                                                                        "type": "string"
                                                                    },
                                                                    "filter": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "object",
                                                                                "title": "WhereFilterIntersection",
                                                                                "properties": {
                                                                                    "where_filters": {
                                                                                        "type": "array",
                                                                                        "items": {
                                                                                            "type": "object",
                                                                                            "title": "WhereFilter",
                                                                                            "properties": {
                                                                                                "where_sql_template": {
                                                                                                    "type": "string"
                                                                                                }
                                                                                            },
                                                                                            "additionalProperties": false,
                                                                                            "required": [
                                                                                                "where_sql_template"
                                                                                            ]
                                                                                        }
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "where_filters"
                                                                                ]
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    },
                                                                    "alias": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    },
                                                                    "offset_window": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "object",
                                                                                "title": "MetricTimeWindow",
                                                                                "properties": {
                                                                                    "count": {
                                                                                        "type": "integer"
                                                                                    },
                                                                                    "granularity": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "count",
                                                                                    "granularity"
                                                                                ]
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    },
                                                                    "offset_to_grain": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "name"
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "conversion_type_params": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "ConversionTypeParams",
                                                            "properties": {
                                                                "base_measure": {
                                                                    "type": "object",
                                                                    "title": "MetricInputMeasure",
                                                                    "properties": {
                                                                        "name": {
                                                                            "type": "string"
                                                                        },
                                                                        "filter": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "object",
                                                                                    "title": "WhereFilterIntersection",
                                                                                    "properties": {
                                                                                        "where_filters": {
                                                                                            "type": "array",
                                                                                            "items": {
                                                                                                "type": "object",
                                                                                                "title": "WhereFilter",
                                                                                                "properties": {
                                                                                                    "where_sql_template": {
                                                                                                        "type": "string"
                                                                                                    }
                                                                                                },
                                                                                                "additionalProperties": false,
                                                                                                "required": [
                                                                                                    "where_sql_template"
                                                                                                ]
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    "additionalProperties": false,
                                                                                    "required": [
                                                                                        "where_filters"
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "alias": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "join_to_timespine": {
                                                                            "type": "boolean",
                                                                            "default": false
                                                                        },
                                                                        "fill_nulls_with": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "name"
                                                                    ]
                                                                },
                                                                "conversion_measure": {
                                                                    "type": "object",
                                                                    "title": "MetricInputMeasure",
                                                                    "properties": {
                                                                        "name": {
                                                                            "type": "string"
                                                                        },
                                                                        "filter": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "object",
                                                                                    "title": "WhereFilterIntersection",
                                                                                    "properties": {
                                                                                        "where_filters": {
                                                                                            "type": "array",
                                                                                            "items": {
                                                                                                "type": "object",
                                                                                                "title": "WhereFilter",
                                                                                                "properties": {
                                                                                                    "where_sql_template": {
                                                                                                        "type": "string"
                                                                                                    }
                                                                                                },
                                                                                                "additionalProperties": false,
                                                                                                "required": [
                                                                                                    "where_sql_template"
                                                                                                ]
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    "additionalProperties": false,
                                                                                    "required": [
                                                                                        "where_filters"
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "alias": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "string"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        },
                                                                        "join_to_timespine": {
                                                                            "type": "boolean",
                                                                            "default": false
                                                                        },
                                                                        "fill_nulls_with": {
                                                                            "anyOf": [
                                                                                {
                                                                                    "type": "integer"
                                                                                },
                                                                                {
                                                                                    "type": "null"
                                                                                }
                                                                            ],
                                                                            "default": null
                                                                        }
                                                                    },
                                                                    "additionalProperties": false,
                                                                    "required": [
                                                                        "name"
                                                                    ]
                                                                },
                                                                "entity": {
                                                                    "type": "string"
                                                                },
                                                                "calculation": {
                                                                    "enum": [
                                                                        "conversions",
                                                                        "conversion_rate"
                                                                    ],
                                                                    "default": "conversion_rate"
                                                                },
                                                                "window": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "MetricTimeWindow",
                                                                            "properties": {
                                                                                "count": {
                                                                                    "type": "integer"
                                                                                },
                                                                                "granularity": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "count",
                                                                                "granularity"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "constant_properties": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "array",
                                                                            "items": {
                                                                                "type": "object",
                                                                                "title": "ConstantPropertyInput",
                                                                                "properties": {
                                                                                    "base_property": {
                                                                                        "type": "string"
                                                                                    },
                                                                                    "conversion_property": {
                                                                                        "type": "string"
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false,
                                                                                "required": [
                                                                                    "base_property",
                                                                                    "conversion_property"
                                                                                ]
                                                                            }
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "base_measure",
                                                                "conversion_measure",
                                                                "entity"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "cumulative_type_params": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "CumulativeTypeParams",
                                                            "properties": {
                                                                "window": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "object",
                                                                            "title": "MetricTimeWindow",
                                                                            "properties": {
                                                                                "count": {
                                                                                    "type": "integer"
                                                                                },
                                                                                "granularity": {
                                                                                    "type": "string"
                                                                                }
                                                                            },
                                                                            "additionalProperties": false,
                                                                            "required": [
                                                                                "count",
                                                                                "granularity"
                                                                            ]
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "grain_to_date": {
                                                                    "anyOf": [
                                                                        {
                                                                            "type": "string"
                                                                        },
                                                                        {
                                                                            "type": "null"
                                                                        }
                                                                    ],
                                                                    "default": null
                                                                },
                                                                "period_agg": {
                                                                    "enum": [
                                                                        "first",
                                                                        "last",
                                                                        "average"
                                                                    ],
                                                                    "default": "first"
                                                                }
                                                            },
                                                            "additionalProperties": false
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "filter": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "WhereFilterIntersection",
                                                    "properties": {
                                                        "where_filters": {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "object",
                                                                "title": "WhereFilter",
                                                                "properties": {
                                                                    "where_sql_template": {
                                                                        "type": "string"
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "where_sql_template"
                                                                ]
                                                            }
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "where_filters"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "metadata": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "SourceFileMetadata",
                                                    "properties": {
                                                        "repo_file_path": {
                                                            "type": "string"
                                                        },
                                                        "file_slice": {
                                                            "type": "object",
                                                            "title": "FileSlice",
                                                            "properties": {
                                                                "filename": {
                                                                    "type": "string"
                                                                },
                                                                "content": {
                                                                    "type": "string"
                                                                },
                                                                "start_line_number": {
                                                                    "type": "integer"
                                                                },
                                                                "end_line_number": {
                                                                    "type": "integer"
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "filename",
                                                                "content",
                                                                "start_line_number",
                                                                "end_line_number"
                                                            ]
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "repo_file_path",
                                                        "file_slice"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "time_granularity": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "meta": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "tags": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "MetricConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "sources": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "metrics": {
                                            "type": "array",
                                            "items": {
                                                "type": "array",
                                                "items": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "description",
                                        "label",
                                        "type",
                                        "type_params"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "SavedQuery",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "const": "saved_query"
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "query_params": {
                                            "type": "object",
                                            "title": "QueryParams",
                                            "properties": {
                                                "metrics": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "group_by": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "where": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "WhereFilterIntersection",
                                                            "properties": {
                                                                "where_filters": {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "type": "object",
                                                                        "title": "WhereFilter",
                                                                        "properties": {
                                                                            "where_sql_template": {
                                                                                "type": "string"
                                                                            }
                                                                        },
                                                                        "additionalProperties": false,
                                                                        "required": [
                                                                            "where_sql_template"
                                                                        ]
                                                                    }
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "where_filters"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ]
                                                },
                                                "order_by": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "limit": {
                                                    "anyOf": [
                                                        {
                                                            "type": "integer"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": [
                                                "metrics",
                                                "group_by",
                                                "where"
                                            ]
                                        },
                                        "exports": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "Export",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "config": {
                                                        "type": "object",
                                                        "title": "ExportConfig",
                                                        "properties": {
                                                            "export_as": {
                                                                "enum": [
                                                                    "table",
                                                                    "view"
                                                                ]
                                                            },
                                                            "schema_name": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "alias": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            },
                                                            "database": {
                                                                "anyOf": [
                                                                    {
                                                                        "type": "string"
                                                                    },
                                                                    {
                                                                        "type": "null"
                                                                    }
                                                                ],
                                                                "default": null
                                                            }
                                                        },
                                                        "additionalProperties": false,
                                                        "required": [
                                                            "export_as"
                                                        ]
                                                    },
                                                    "unrendered_config": {
                                                        "type": "object",
                                                        "additionalProperties": {
                                                            "type": "string"
                                                        },
                                                        "propertyNames": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name", "config"]
                                            }
                                        },
                                        "description": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "label": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "metadata": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "SourceFileMetadata",
                                                    "properties": {
                                                        "repo_file_path": {
                                                            "type": "string"
                                                        },
                                                        "file_slice": {
                                                            "type": "object",
                                                            "title": "FileSlice",
                                                            "properties": {
                                                                "filename": {
                                                                    "type": "string"
                                                                },
                                                                "content": {
                                                                    "type": "string"
                                                                },
                                                                "start_line_number": {
                                                                    "type": "integer"
                                                                },
                                                                "end_line_number": {
                                                                    "type": "integer"
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "filename",
                                                                "content",
                                                                "start_line_number",
                                                                "end_line_number"
                                                            ]
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "repo_file_path",
                                                        "file_slice"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "SavedQueryConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "export_as": {
                                                    "anyOf": [
                                                        {
                                                            "enum": [
                                                                "table",
                                                                "view"
                                                            ]
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "schema": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "cache": {
                                                    "type": "object",
                                                    "title": "SavedQueryCache",
                                                    "properties": {
                                                        "enabled": {
                                                            "type": "boolean",
                                                            "default": false
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "tags": {
                                            "anyOf": [
                                                {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                {
                                                    "type": "string"
                                                }
                                            ]
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "query_params",
                                        "exports"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "SemanticModel",
                                    "properties": {
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "enum": [
                                                "model",
                                                "analysis",
                                                "test",
                                                "snapshot",
                                                "operation",
                                                "seed",
                                                "rpc",
                                                "sql_operation",
                                                "doc",
                                                "source",
                                                "macro",
                                                "exposure",
                                                "metric",
                                                "group",
                                                "saved_query",
                                                "semantic_model",
                                                "unit_test",
                                                "fixture"
                                            ]
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "model": {
                                            "type": "string"
                                        },
                                        "node_relation": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "NodeRelation",
                                                    "properties": {
                                                        "alias": {
                                                            "type": "string"
                                                        },
                                                        "schema_name": {
                                                            "type": "string"
                                                        },
                                                        "database": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "relation_name": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": ""
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "alias",
                                                        "schema_name"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ]
                                        },
                                        "description": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "label": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "defaults": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "Defaults",
                                                    "properties": {
                                                        "agg_time_dimension": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "string"
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "entities": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "Entity",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "type": {
                                                        "enum": [
                                                            "foreign",
                                                            "natural",
                                                            "primary",
                                                            "unique"
                                                        ]
                                                    },
                                                    "description": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "label": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "role": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expr": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "config": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "SemanticLayerElementConfig",
                                                                "properties": {
                                                                    "meta": {
                                                                        "type": "object",
                                                                        "propertyNames": {
                                                                            "type": "string"
                                                                        }
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name", "type"]
                                            }
                                        },
                                        "measures": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "Measure",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "agg": {
                                                        "enum": [
                                                            "sum",
                                                            "min",
                                                            "max",
                                                            "count_distinct",
                                                            "sum_boolean",
                                                            "average",
                                                            "percentile",
                                                            "median",
                                                            "count"
                                                        ]
                                                    },
                                                    "description": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "label": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "create_metric": {
                                                        "type": "boolean",
                                                        "default": false
                                                    },
                                                    "expr": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "agg_params": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "MeasureAggregationParameters",
                                                                "properties": {
                                                                    "percentile": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "number"
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    },
                                                                    "use_discrete_percentile": {
                                                                        "type": "boolean",
                                                                        "default": false
                                                                    },
                                                                    "use_approximate_percentile": {
                                                                        "type": "boolean",
                                                                        "default": false
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "non_additive_dimension": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "NonAdditiveDimension",
                                                                "properties": {
                                                                    "name": {
                                                                        "type": "string"
                                                                    },
                                                                    "window_choice": {
                                                                        "enum": [
                                                                            "sum",
                                                                            "min",
                                                                            "max",
                                                                            "count_distinct",
                                                                            "sum_boolean",
                                                                            "average",
                                                                            "percentile",
                                                                            "median",
                                                                            "count"
                                                                        ]
                                                                    },
                                                                    "window_groupings": {
                                                                        "type": "array",
                                                                        "items": {
                                                                            "type": "string"
                                                                        }
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "name",
                                                                    "window_choice",
                                                                    "window_groupings"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "agg_time_dimension": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "config": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "SemanticLayerElementConfig",
                                                                "properties": {
                                                                    "meta": {
                                                                        "type": "object",
                                                                        "propertyNames": {
                                                                            "type": "string"
                                                                        }
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name", "agg"]
                                            }
                                        },
                                        "dimensions": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "Dimension",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "type": {
                                                        "enum": [
                                                            "categorical",
                                                            "time"
                                                        ]
                                                    },
                                                    "description": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "label": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "is_partition": {
                                                        "type": "boolean",
                                                        "default": false
                                                    },
                                                    "type_params": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "DimensionTypeParams",
                                                                "properties": {
                                                                    "time_granularity": {
                                                                        "enum": [
                                                                            "nanosecond",
                                                                            "microsecond",
                                                                            "millisecond",
                                                                            "second",
                                                                            "minute",
                                                                            "hour",
                                                                            "day",
                                                                            "week",
                                                                            "month",
                                                                            "quarter",
                                                                            "year"
                                                                        ]
                                                                    },
                                                                    "validity_params": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "object",
                                                                                "title": "DimensionValidityParams",
                                                                                "properties": {
                                                                                    "is_start": {
                                                                                        "type": "boolean",
                                                                                        "default": false
                                                                                    },
                                                                                    "is_end": {
                                                                                        "type": "boolean",
                                                                                        "default": false
                                                                                    }
                                                                                },
                                                                                "additionalProperties": false
                                                                            },
                                                                            {
                                                                                "type": "null"
                                                                            }
                                                                        ],
                                                                        "default": null
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "time_granularity"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "expr": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "metadata": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "SourceFileMetadata",
                                                                "properties": {
                                                                    "repo_file_path": {
                                                                        "type": "string"
                                                                    },
                                                                    "file_slice": {
                                                                        "type": "object",
                                                                        "title": "FileSlice",
                                                                        "properties": {
                                                                            "filename": {
                                                                                "type": "string"
                                                                            },
                                                                            "content": {
                                                                                "type": "string"
                                                                            },
                                                                            "start_line_number": {
                                                                                "type": "integer"
                                                                            },
                                                                            "end_line_number": {
                                                                                "type": "integer"
                                                                            }
                                                                        },
                                                                        "additionalProperties": false,
                                                                        "required": [
                                                                            "filename",
                                                                            "content",
                                                                            "start_line_number",
                                                                            "end_line_number"
                                                                        ]
                                                                    }
                                                                },
                                                                "additionalProperties": false,
                                                                "required": [
                                                                    "repo_file_path",
                                                                    "file_slice"
                                                                ]
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "config": {
                                                        "anyOf": [
                                                            {
                                                                "type": "object",
                                                                "title": "SemanticLayerElementConfig",
                                                                "properties": {
                                                                    "meta": {
                                                                        "type": "object",
                                                                        "propertyNames": {
                                                                            "type": "string"
                                                                        }
                                                                    }
                                                                },
                                                                "additionalProperties": false
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name", "type"]
                                            }
                                        },
                                        "metadata": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "SourceFileMetadata",
                                                    "properties": {
                                                        "repo_file_path": {
                                                            "type": "string"
                                                        },
                                                        "file_slice": {
                                                            "type": "object",
                                                            "title": "FileSlice",
                                                            "properties": {
                                                                "filename": {
                                                                    "type": "string"
                                                                },
                                                                "content": {
                                                                    "type": "string"
                                                                },
                                                                "start_line_number": {
                                                                    "type": "integer"
                                                                },
                                                                "end_line_number": {
                                                                    "type": "integer"
                                                                }
                                                            },
                                                            "additionalProperties": false,
                                                            "required": [
                                                                "filename",
                                                                "content",
                                                                "start_line_number",
                                                                "end_line_number"
                                                            ]
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "repo_file_path",
                                                        "file_slice"
                                                    ]
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "refs": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "RefArgs",
                                                "properties": {
                                                    "name": {
                                                        "type": "string"
                                                    },
                                                    "package": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "version": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "number"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["name"]
                                            }
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "SemanticModelConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                },
                                                "group": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "unrendered_config": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        },
                                        "primary_entity": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "group": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn",
                                        "model",
                                        "node_relation"
                                    ]
                                },
                                {
                                    "type": "object",
                                    "title": "UnitTestDefinition",
                                    "properties": {
                                        "model": {
                                            "type": "string"
                                        },
                                        "given": {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "title": "UnitTestInputFixture",
                                                "properties": {
                                                    "input": {
                                                        "type": "string"
                                                    },
                                                    "rows": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "array",
                                                                "items": {
                                                                    "type": "object",
                                                                    "propertyNames": {
                                                                        "type": "string"
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    },
                                                    "format": {
                                                        "enum": [
                                                            "csv",
                                                            "dict",
                                                            "sql"
                                                        ],
                                                        "default": "dict"
                                                    },
                                                    "fixture": {
                                                        "anyOf": [
                                                            {
                                                                "type": "string"
                                                            },
                                                            {
                                                                "type": "null"
                                                            }
                                                        ],
                                                        "default": null
                                                    }
                                                },
                                                "additionalProperties": false,
                                                "required": ["input"]
                                            }
                                        },
                                        "expect": {
                                            "type": "object",
                                            "title": "UnitTestOutputFixture",
                                            "properties": {
                                                "rows": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "object",
                                                                "propertyNames": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "format": {
                                                    "enum": [
                                                        "csv",
                                                        "dict",
                                                        "sql"
                                                    ],
                                                    "default": "dict"
                                                },
                                                "fixture": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "name": {
                                            "type": "string"
                                        },
                                        "resource_type": {
                                            "enum": [
                                                "model",
                                                "analysis",
                                                "test",
                                                "snapshot",
                                                "operation",
                                                "seed",
                                                "rpc",
                                                "sql_operation",
                                                "doc",
                                                "source",
                                                "macro",
                                                "exposure",
                                                "metric",
                                                "group",
                                                "saved_query",
                                                "semantic_model",
                                                "unit_test",
                                                "fixture"
                                            ]
                                        },
                                        "package_name": {
                                            "type": "string"
                                        },
                                        "path": {
                                            "type": "string"
                                        },
                                        "original_file_path": {
                                            "type": "string"
                                        },
                                        "unique_id": {
                                            "type": "string"
                                        },
                                        "fqn": {
                                            "type": "array",
                                            "items": {
                                                "type": "string"
                                            }
                                        },
                                        "description": {
                                            "type": "string",
                                            "default": ""
                                        },
                                        "overrides": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "UnitTestOverrides",
                                                    "properties": {
                                                        "macros": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "vars": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        },
                                                        "env_vars": {
                                                            "type": "object",
                                                            "propertyNames": {
                                                                "type": "string"
                                                            }
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "depends_on": {
                                            "type": "object",
                                            "title": "DependsOn",
                                            "properties": {
                                                "macros": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "nodes": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        "config": {
                                            "type": "object",
                                            "title": "UnitTestConfig",
                                            "properties": {
                                                "_extra": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "tags": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "array",
                                                            "items": {
                                                                "type": "string"
                                                            }
                                                        }
                                                    ]
                                                },
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                },
                                                "enabled": {
                                                    "type": "boolean",
                                                    "default": true
                                                }
                                            },
                                            "additionalProperties": true
                                        },
                                        "checksum": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "schema": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "created_at": {
                                            "type": "number"
                                        },
                                        "versions": {
                                            "anyOf": [
                                                {
                                                    "type": "object",
                                                    "title": "UnitTestNodeVersions",
                                                    "properties": {
                                                        "include": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "number"
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        },
                                                        "exclude": {
                                                            "anyOf": [
                                                                {
                                                                    "type": "array",
                                                                    "items": {
                                                                        "anyOf": [
                                                                            {
                                                                                "type": "string"
                                                                            },
                                                                            {
                                                                                "type": "number"
                                                                            }
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    "type": "null"
                                                                }
                                                            ],
                                                            "default": null
                                                        }
                                                    },
                                                    "additionalProperties": false
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "version": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "number"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": [
                                        "model",
                                        "given",
                                        "expect",
                                        "name",
                                        "resource_type",
                                        "package_name",
                                        "path",
                                        "original_file_path",
                                        "unique_id",
                                        "fqn"
                                    ]
                                }
                            ]
                        }
                    },
                    "propertyNames": {
                        "type": "string"
                    }
                },
                {
                    "type": "null"
                }
            ]
        },
        "parent_map": {
            "description": "A mapping from\u00a0child nodes to their dependencies",
            "anyOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "propertyNames": {
                        "type": "string"
                    }
                },
                {
                    "type": "null"
                }
            ]
        },
        "child_map": {
            "description": "A mapping from parent nodes to their dependents",
            "anyOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "propertyNames": {
                        "type": "string"
                    }
                },
                {
                    "type": "null"
                }
            ]
        },
        "group_map": {
            "description": "A mapping from group names to their nodes",
            "anyOf": [
                {
                    "type": "object",
                    "additionalProperties": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "propertyNames": {
                        "type": "string"
                    }
                },
                {
                    "type": "null"
                }
            ]
        },
        "saved_queries": {
            "type": "object",
            "description": "The saved queries defined in the dbt project",
            "additionalProperties": {
                "type": "object",
                "title": "SavedQuery",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "const": "saved_query"
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "fqn": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "query_params": {
                        "type": "object",
                        "title": "QueryParams",
                        "properties": {
                            "metrics": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "group_by": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "where": {
                                "anyOf": [
                                    {
                                        "type": "object",
                                        "title": "WhereFilterIntersection",
                                        "properties": {
                                            "where_filters": {
                                                "type": "array",
                                                "items": {
                                                    "type": "object",
                                                    "title": "WhereFilter",
                                                    "properties": {
                                                        "where_sql_template": {
                                                            "type": "string"
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "where_sql_template"
                                                    ]
                                                }
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": ["where_filters"]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ]
                            },
                            "order_by": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "limit": {
                                "anyOf": [
                                    {
                                        "type": "integer"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false,
                        "required": ["metrics", "group_by", "where"]
                    },
                    "exports": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "Export",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "config": {
                                    "type": "object",
                                    "title": "ExportConfig",
                                    "properties": {
                                        "export_as": {
                                            "enum": ["table", "view"]
                                        },
                                        "schema_name": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "alias": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        },
                                        "database": {
                                            "anyOf": [
                                                {
                                                    "type": "string"
                                                },
                                                {
                                                    "type": "null"
                                                }
                                            ],
                                            "default": null
                                        }
                                    },
                                    "additionalProperties": false,
                                    "required": ["export_as"]
                                },
                                "unrendered_config": {
                                    "type": "object",
                                    "additionalProperties": {
                                        "type": "string"
                                    },
                                    "propertyNames": {
                                        "type": "string"
                                    }
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name", "config"]
                        }
                    },
                    "description": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "label": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "metadata": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "SourceFileMetadata",
                                "properties": {
                                    "repo_file_path": {
                                        "type": "string"
                                    },
                                    "file_slice": {
                                        "type": "object",
                                        "title": "FileSlice",
                                        "properties": {
                                            "filename": {
                                                "type": "string"
                                            },
                                            "content": {
                                                "type": "string"
                                            },
                                            "start_line_number": {
                                                "type": "integer"
                                            },
                                            "end_line_number": {
                                                "type": "integer"
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "filename",
                                            "content",
                                            "start_line_number",
                                            "end_line_number"
                                        ]
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["repo_file_path", "file_slice"]
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "config": {
                        "type": "object",
                        "title": "SavedQueryConfig",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "enabled": {
                                "type": "boolean",
                                "default": true
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "export_as": {
                                "anyOf": [
                                    {
                                        "enum": ["table", "view"]
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "schema": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "cache": {
                                "type": "object",
                                "title": "SavedQueryCache",
                                "properties": {
                                    "enabled": {
                                        "type": "boolean",
                                        "default": false
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "additionalProperties": true
                    },
                    "unrendered_config": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "group": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "depends_on": {
                        "type": "object",
                        "title": "DependsOn",
                        "properties": {
                            "macros": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "nodes": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    },
                    "created_at": {
                        "type": "number"
                    },
                    "refs": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "RefArgs",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "package": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "version": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "number"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name"]
                        }
                    },
                    "tags": {
                        "anyOf": [
                            {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            {
                                "type": "string"
                            }
                        ]
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "fqn",
                    "query_params",
                    "exports"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "semantic_models": {
            "type": "object",
            "description": "The semantic models defined in the dbt project",
            "additionalProperties": {
                "type": "object",
                "title": "SemanticModel",
                "properties": {
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "enum": [
                            "model",
                            "analysis",
                            "test",
                            "snapshot",
                            "operation",
                            "seed",
                            "rpc",
                            "sql_operation",
                            "doc",
                            "source",
                            "macro",
                            "exposure",
                            "metric",
                            "group",
                            "saved_query",
                            "semantic_model",
                            "unit_test",
                            "fixture"
                        ]
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "fqn": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "model": {
                        "type": "string"
                    },
                    "node_relation": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "NodeRelation",
                                "properties": {
                                    "alias": {
                                        "type": "string"
                                    },
                                    "schema_name": {
                                        "type": "string"
                                    },
                                    "database": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "relation_name": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": ""
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["alias", "schema_name"]
                            },
                            {
                                "type": "null"
                            }
                        ]
                    },
                    "description": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "label": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "defaults": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "Defaults",
                                "properties": {
                                    "agg_time_dimension": {
                                        "anyOf": [
                                            {
                                                "type": "string"
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "entities": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "Entity",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "type": {
                                    "enum": [
                                        "foreign",
                                        "natural",
                                        "primary",
                                        "unique"
                                    ]
                                },
                                "description": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "label": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "role": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "expr": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "config": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "SemanticLayerElementConfig",
                                            "properties": {
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name", "type"]
                        }
                    },
                    "measures": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "Measure",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "agg": {
                                    "enum": [
                                        "sum",
                                        "min",
                                        "max",
                                        "count_distinct",
                                        "sum_boolean",
                                        "average",
                                        "percentile",
                                        "median",
                                        "count"
                                    ]
                                },
                                "description": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "label": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "create_metric": {
                                    "type": "boolean",
                                    "default": false
                                },
                                "expr": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "agg_params": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "MeasureAggregationParameters",
                                            "properties": {
                                                "percentile": {
                                                    "anyOf": [
                                                        {
                                                            "type": "number"
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                },
                                                "use_discrete_percentile": {
                                                    "type": "boolean",
                                                    "default": false
                                                },
                                                "use_approximate_percentile": {
                                                    "type": "boolean",
                                                    "default": false
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "non_additive_dimension": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "NonAdditiveDimension",
                                            "properties": {
                                                "name": {
                                                    "type": "string"
                                                },
                                                "window_choice": {
                                                    "enum": [
                                                        "sum",
                                                        "min",
                                                        "max",
                                                        "count_distinct",
                                                        "sum_boolean",
                                                        "average",
                                                        "percentile",
                                                        "median",
                                                        "count"
                                                    ]
                                                },
                                                "window_groupings": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": [
                                                "name",
                                                "window_choice",
                                                "window_groupings"
                                            ]
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "agg_time_dimension": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "config": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "SemanticLayerElementConfig",
                                            "properties": {
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name", "agg"]
                        }
                    },
                    "dimensions": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "Dimension",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "type": {
                                    "enum": ["categorical", "time"]
                                },
                                "description": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "label": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "is_partition": {
                                    "type": "boolean",
                                    "default": false
                                },
                                "type_params": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "DimensionTypeParams",
                                            "properties": {
                                                "time_granularity": {
                                                    "enum": [
                                                        "nanosecond",
                                                        "microsecond",
                                                        "millisecond",
                                                        "second",
                                                        "minute",
                                                        "hour",
                                                        "day",
                                                        "week",
                                                        "month",
                                                        "quarter",
                                                        "year"
                                                    ]
                                                },
                                                "validity_params": {
                                                    "anyOf": [
                                                        {
                                                            "type": "object",
                                                            "title": "DimensionValidityParams",
                                                            "properties": {
                                                                "is_start": {
                                                                    "type": "boolean",
                                                                    "default": false
                                                                },
                                                                "is_end": {
                                                                    "type": "boolean",
                                                                    "default": false
                                                                }
                                                            },
                                                            "additionalProperties": false
                                                        },
                                                        {
                                                            "type": "null"
                                                        }
                                                    ],
                                                    "default": null
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": ["time_granularity"]
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "expr": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "metadata": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "SourceFileMetadata",
                                            "properties": {
                                                "repo_file_path": {
                                                    "type": "string"
                                                },
                                                "file_slice": {
                                                    "type": "object",
                                                    "title": "FileSlice",
                                                    "properties": {
                                                        "filename": {
                                                            "type": "string"
                                                        },
                                                        "content": {
                                                            "type": "string"
                                                        },
                                                        "start_line_number": {
                                                            "type": "integer"
                                                        },
                                                        "end_line_number": {
                                                            "type": "integer"
                                                        }
                                                    },
                                                    "additionalProperties": false,
                                                    "required": [
                                                        "filename",
                                                        "content",
                                                        "start_line_number",
                                                        "end_line_number"
                                                    ]
                                                }
                                            },
                                            "additionalProperties": false,
                                            "required": [
                                                "repo_file_path",
                                                "file_slice"
                                            ]
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "config": {
                                    "anyOf": [
                                        {
                                            "type": "object",
                                            "title": "SemanticLayerElementConfig",
                                            "properties": {
                                                "meta": {
                                                    "type": "object",
                                                    "propertyNames": {
                                                        "type": "string"
                                                    }
                                                }
                                            },
                                            "additionalProperties": false
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name", "type"]
                        }
                    },
                    "metadata": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "SourceFileMetadata",
                                "properties": {
                                    "repo_file_path": {
                                        "type": "string"
                                    },
                                    "file_slice": {
                                        "type": "object",
                                        "title": "FileSlice",
                                        "properties": {
                                            "filename": {
                                                "type": "string"
                                            },
                                            "content": {
                                                "type": "string"
                                            },
                                            "start_line_number": {
                                                "type": "integer"
                                            },
                                            "end_line_number": {
                                                "type": "integer"
                                            }
                                        },
                                        "additionalProperties": false,
                                        "required": [
                                            "filename",
                                            "content",
                                            "start_line_number",
                                            "end_line_number"
                                        ]
                                    }
                                },
                                "additionalProperties": false,
                                "required": ["repo_file_path", "file_slice"]
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "depends_on": {
                        "type": "object",
                        "title": "DependsOn",
                        "properties": {
                            "macros": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "nodes": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    },
                    "refs": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "RefArgs",
                            "properties": {
                                "name": {
                                    "type": "string"
                                },
                                "package": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "version": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "number"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["name"]
                        }
                    },
                    "created_at": {
                        "type": "number"
                    },
                    "config": {
                        "type": "object",
                        "title": "SemanticModelConfig",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "enabled": {
                                "type": "boolean",
                                "default": true
                            },
                            "group": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": true
                    },
                    "unrendered_config": {
                        "type": "object",
                        "propertyNames": {
                            "type": "string"
                        }
                    },
                    "primary_entity": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "group": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    }
                },
                "additionalProperties": false,
                "required": [
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "fqn",
                    "model",
                    "node_relation"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        },
        "unit_tests": {
            "type": "object",
            "description": "The unit tests defined in the project",
            "additionalProperties": {
                "type": "object",
                "title": "UnitTestDefinition",
                "properties": {
                    "model": {
                        "type": "string"
                    },
                    "given": {
                        "type": "array",
                        "items": {
                            "type": "object",
                            "title": "UnitTestInputFixture",
                            "properties": {
                                "input": {
                                    "type": "string"
                                },
                                "rows": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "array",
                                            "items": {
                                                "type": "object",
                                                "propertyNames": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                },
                                "format": {
                                    "enum": ["csv", "dict", "sql"],
                                    "default": "dict"
                                },
                                "fixture": {
                                    "anyOf": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "null"
                                        }
                                    ],
                                    "default": null
                                }
                            },
                            "additionalProperties": false,
                            "required": ["input"]
                        }
                    },
                    "expect": {
                        "type": "object",
                        "title": "UnitTestOutputFixture",
                        "properties": {
                            "rows": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "object",
                                            "propertyNames": {
                                                "type": "string"
                                            }
                                        }
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            },
                            "format": {
                                "enum": ["csv", "dict", "sql"],
                                "default": "dict"
                            },
                            "fixture": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "null"
                                    }
                                ],
                                "default": null
                            }
                        },
                        "additionalProperties": false
                    },
                    "name": {
                        "type": "string"
                    },
                    "resource_type": {
                        "enum": [
                            "model",
                            "analysis",
                            "test",
                            "snapshot",
                            "operation",
                            "seed",
                            "rpc",
                            "sql_operation",
                            "doc",
                            "source",
                            "macro",
                            "exposure",
                            "metric",
                            "group",
                            "saved_query",
                            "semantic_model",
                            "unit_test",
                            "fixture"
                        ]
                    },
                    "package_name": {
                        "type": "string"
                    },
                    "path": {
                        "type": "string"
                    },
                    "original_file_path": {
                        "type": "string"
                    },
                    "unique_id": {
                        "type": "string"
                    },
                    "fqn": {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    "description": {
                        "type": "string",
                        "default": ""
                    },
                    "overrides": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "UnitTestOverrides",
                                "properties": {
                                    "macros": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "vars": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    },
                                    "env_vars": {
                                        "type": "object",
                                        "propertyNames": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "additionalProperties": false
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "depends_on": {
                        "type": "object",
                        "title": "DependsOn",
                        "properties": {
                            "macros": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "nodes": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            }
                        },
                        "additionalProperties": false
                    },
                    "config": {
                        "type": "object",
                        "title": "UnitTestConfig",
                        "properties": {
                            "_extra": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "tags": {
                                "anyOf": [
                                    {
                                        "type": "string"
                                    },
                                    {
                                        "type": "array",
                                        "items": {
                                            "type": "string"
                                        }
                                    }
                                ]
                            },
                            "meta": {
                                "type": "object",
                                "propertyNames": {
                                    "type": "string"
                                }
                            },
                            "enabled": {
                                "type": "boolean",
                                "default": true
                            }
                        },
                        "additionalProperties": true
                    },
                    "checksum": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "schema": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "created_at": {
                        "type": "number"
                    },
                    "versions": {
                        "anyOf": [
                            {
                                "type": "object",
                                "title": "UnitTestNodeVersions",
                                "properties": {
                                    "include": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "number"
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    },
                                    "exclude": {
                                        "anyOf": [
                                            {
                                                "type": "array",
                                                "items": {
                                                    "anyOf": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "number"
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "type": "null"
                                            }
                                        ],
                                        "default": null
                                    }
                                },
                                "additionalProperties": false
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    },
                    "version": {
                        "anyOf": [
                            {
                                "type": "string"
                            },
                            {
                                "type": "number"
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "default": null
                    }
                },
                "additionalProperties": false,
                "required": [
                    "model",
                    "given",
                    "expect",
                    "name",
                    "resource_type",
                    "package_name",
                    "path",
                    "original_file_path",
                    "unique_id",
                    "fqn"
                ]
            },
            "propertyNames": {
                "type": "string"
            }
        }
    },
    "additionalProperties": false,
    "required": [
        "metadata",
        "nodes",
        "sources",
        "macros",
        "docs",
        "exposures",
        "metrics",
        "groups",
        "selectors",
        "disabled",
        "parent_map",
        "child_map",
        "group_map",
        "saved_queries",
        "semantic_models",
        "unit_tests"
    ],
    "$id": "https://schemas.getdbt.com/dbt/manifest/v12.json"
}
